export const ataStatic = {
    "activeEnrollment": true,
    "offLine": false,
    "enableRenewals": true,
    "renewal": false,
    "application": {
        "applicationId": 2,
        "applicationName": "ATA",
        "createUser": null,
        "createDate": "0001-01-01T00:00:00",
        "lastUpdatedUser": null,
        "lastUpdatedDate": null,
        "disabled": false,
        "systemNotes": null,
        "userEmail": null,
        "errors": [],
        "isSuccessful": true
    },
    "participant": null,
    "agent": null,
    "programEnrollment": {
        "programEnrollmentId": 4,
        "description": "ATA",
        "stateId": 54,
        "stateCode": "VA",
        "useSurplusLines": true,
        "policyEffectiveStartDate": null,
        "policyEffectiveEndDate": null,
        "enrollmentAsOfStartDate": null,
        "enrollmentAsOfEndDate": null,
        "enableRenewals": true,
        "renewalDays": 90,
        "lapseInCoverageDays": 10,
        "programId": 4,
        "enrollmentWindowId": 1,
        "masterPolicyId": null,
        "supportEmail": "stephen.nelson@alliant;walid.chlioui@alliant.com;kyler.beck@alliant.com;sean.murray@alliant.com;sean.rich@alliant.com;vivian.le@alliant.com",
        "premiumFinanceAmsLookupCode": "FIRSINS-01",
        "enableQuotes": true,
        "quoteExpirationDays": 30,
        "quoteExpirationOverride": false,
        "allowPremiumFinance": true,
        "downPaymentPercentage": 0.25,
        "premiumFinanceThreshold": 1500,
        "enrollmentWindowOverride": null,
        "requireReferralNotification": true,
        "autoReferral": true,
        "policyCode": "1PTP",
        "disableCaching": true,
        "policyEffectiveDate": "",
        "parentProgramEnrollmentId": null,
        "parentProgramEnrollment": null,
        "program": {
            "programId": 4,
            "programName": "ATA",
            "programLongName": null,
            "programDescription": null,
            "clientId": 0,
            "epicCode": "ATA",
            "applicationCode": "ATA.ATA",
            "structureCode": "200",
            "applicationId": 2,
            "applicationName": "ATA",
            "offline": false,
            "adminOffline": false,
            "url": "/ata/",
            "programType": 2,
            "showAdminSetting": true,
            "showLandingPage": true,
            "autoPopulateParticipantInfo": true,
            "autoPopulateParticipantRatingItems": true,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:24.1336993",
            "lastUpdatedUser": "Seed.UpdateSeedPrograms",
            "lastUpdatedDate": "2020-02-13T00:07:37.9453134",
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        "enrollmentWindow": {
            "enrollmentWindowId": 1,
            "startDate": null,
            "endDate": null,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:24.1805736",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        "programEnrollmentRatingGroups": [
            {
                "programEnrollmentRatingGroupId": 10,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 6,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 51,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 16,
                        "ratingItemDescription": "Are you an ATA Member?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Are you an ATA Member?",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-51",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Are you an ATA Member?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 52,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 51,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you an ATA Member?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-52",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 54,
                                        "programEnrollmentRatingGroupId": 10,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 52,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 6,
                                        "displaySequence": 4,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 18,
                                        "ratingItemDescription": "If yes, Provide Membership #",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Membership #",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-10-54",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "If yes, Provide Membership #",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 18,
                                            "ratingItemDescription": "If yes, Provide Membership #",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Membership #",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 55,
                                        "programEnrollmentRatingGroupId": 10,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 52,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 6,
                                        "displaySequence": 5,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 17,
                                        "ratingItemDescription": "Are you ATA Certified?",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Are you ATA Certified?",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 3,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Boolean",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 12,
                                        "uiControl": 12,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-10-55",
                                        "visible": true,
                                        "adminVisible": false,
                                        "excludeFromReport": true,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Are you ATA Certified?",
                                        "relatedItems": [
                                            {
                                                "programEnrollmentRatingItemId": 56,
                                                "programEnrollmentRatingGroupId": 10,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 55,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 6,
                                                "displaySequence": 6,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 9998,
                                                "ratingItemDescription": "Yes",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Are you ATA Certified?",
                                                "overrideDescription": "Yes",
                                                "parentRatingType": 3,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 4,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "Selection",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 13,
                                                "uiControl": 13,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-10-56",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Yes",
                                                "relatedItems": [
                                                    {
                                                        "programEnrollmentRatingItemId": 58,
                                                        "programEnrollmentRatingGroupId": 10,
                                                        "programEnrollmentId": 4,
                                                        "parentItemId": 56,
                                                        "sectionDisplaySequence": null,
                                                        "groupDisplaySequence": 6,
                                                        "displaySequence": 8,
                                                        "premium": 0,
                                                        "deductible": null,
                                                        "factor": 0,
                                                        "lowerLimit": null,
                                                        "upperLimit": null,
                                                        "lowerStringLimit": null,
                                                        "upperStringLimit": null,
                                                        "minSelection": null,
                                                        "maxSelection": null,
                                                        "lowerLimitCoverageTypeId": null,
                                                        "upperLimitCoverageTypeId": null,
                                                        "agencyFee": null,
                                                        "isFactorable": false,
                                                        "ratingItemId": 19,
                                                        "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                                        "ratingGroupDescription": "",
                                                        "parentRatingItemDescription": "Yes",
                                                        "overrideDescription": "Language Pairs",
                                                        "parentRatingType": 4,
                                                        "specialInstruction": null,
                                                        "defaultSelectedState": false,
                                                        "value": null,
                                                        "numericDataType": 0,
                                                        "ratingType": 11,
                                                        "groupRatingType": 0,
                                                        "conditional": false,
                                                        "functionType": 0,
                                                        "stringFunctionType": "None",
                                                        "programEnrollmentDocumentId": null,
                                                        "programEnrollmentDocument": null,
                                                        "stringRatingType": "FreeText",
                                                        "minPremium": null,
                                                        "maxPremium": null,
                                                        "uiIsRequired": null,
                                                        "uiIsReadonly": null,
                                                        "uiControlId": 2,
                                                        "uiControl": 2,
                                                        "uiControlAggregateFunctionId": null,
                                                        "uiControlAggregateFunction": 0,
                                                        "stringUiControlAggregateFunction": "None",
                                                        "validationTargetValue": null,
                                                        "validationTargetItemId": null,
                                                        "sectionId": null,
                                                        "sectionName": null,
                                                        "sectionIndicator": false,
                                                        "uniqueIdentifier": "4-10-58",
                                                        "visible": true,
                                                        "adminVisible": true,
                                                        "excludeFromReport": false,
                                                        "semanticItemId": null,
                                                        "semanticParentItemId": null,
                                                        "hint": null,
                                                        "placeHolder": null,
                                                        "mask": null,
                                                        "className": null,
                                                        "display": "If Yes, Provide Language Pairs:",
                                                        "relatedItems": [],
                                                        "isDefault": false,
                                                        "ratingItem": {
                                                            "ratingItemId": 19,
                                                            "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                                            "lowerLimit": null,
                                                            "upperLimit": null,
                                                            "createUser": "Migration.Seeder",
                                                            "createDate": "2020-02-05T00:05:03.7219203",
                                                            "lastUpdatedUser": null,
                                                            "lastUpdatedDate": null,
                                                            "disabled": false,
                                                            "systemNotes": null,
                                                            "userEmail": null,
                                                            "errors": [],
                                                            "isSuccessful": true
                                                        },
                                                        "hasChildren": false,
                                                        "intrinsicValue": null,
                                                        "businessName": "Language Pairs",
                                                        "createUser": "Migration.Seeder",
                                                        "createDate": "2020-02-05T00:05:25.7004791",
                                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                                        "disabled": false,
                                                        "systemNotes": null,
                                                        "userEmail": null,
                                                        "errors": [],
                                                        "isSuccessful": true
                                                    }
                                                ],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 9998,
                                                    "ratingItemDescription": "Yes",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": true,
                                                "intrinsicValue": null,
                                                "businessName": "Yes",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            },
                                            {
                                                "programEnrollmentRatingItemId": 57,
                                                "programEnrollmentRatingGroupId": 10,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 55,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 6,
                                                "displaySequence": 7,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 9999,
                                                "ratingItemDescription": "No",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Are you ATA Certified?",
                                                "overrideDescription": "No",
                                                "parentRatingType": 3,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 4,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "Selection",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 13,
                                                "uiControl": 13,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-10-57",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "No",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 9999,
                                                    "ratingItemDescription": "No",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "No",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            }
                                        ],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 17,
                                            "ratingItemDescription": "Are you ATA Certified?",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": true,
                                        "intrinsicValue": null,
                                        "businessName": "Are you ATA Certified?",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 53,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 51,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you an ATA Member?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-53",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 16,
                            "ratingItemDescription": "Are you an ATA Member?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Are you an ATA Member?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 52,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 51,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you an ATA Member?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-52",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 54,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 52,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 18,
                                "ratingItemDescription": "If yes, Provide Membership #",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Membership #",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-54",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If yes, Provide Membership #",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 18,
                                    "ratingItemDescription": "If yes, Provide Membership #",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Membership #",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 55,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 52,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 5,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 17,
                                "ratingItemDescription": "Are you ATA Certified?",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Are you ATA Certified?",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 3,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Boolean",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 12,
                                "uiControl": 12,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-55",
                                "visible": true,
                                "adminVisible": false,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Are you ATA Certified?",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 56,
                                        "programEnrollmentRatingGroupId": 10,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 55,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 6,
                                        "displaySequence": 6,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9998,
                                        "ratingItemDescription": "Yes",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Are you ATA Certified?",
                                        "overrideDescription": "Yes",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-10-56",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Yes",
                                        "relatedItems": [
                                            {
                                                "programEnrollmentRatingItemId": 58,
                                                "programEnrollmentRatingGroupId": 10,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 56,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 6,
                                                "displaySequence": 8,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 19,
                                                "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Language Pairs",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 2,
                                                "uiControl": 2,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-10-58",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "If Yes, Provide Language Pairs:",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 19,
                                                    "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Language Pairs",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            }
                                        ],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9998,
                                            "ratingItemDescription": "Yes",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": true,
                                        "intrinsicValue": null,
                                        "businessName": "Yes",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 57,
                                        "programEnrollmentRatingGroupId": 10,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 55,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 6,
                                        "displaySequence": 7,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9999,
                                        "ratingItemDescription": "No",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Are you ATA Certified?",
                                        "overrideDescription": "No",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-10-57",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "No",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9999,
                                            "ratingItemDescription": "No",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "No",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 17,
                                    "ratingItemDescription": "Are you ATA Certified?",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Are you ATA Certified?",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                                "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 52,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 51,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you an ATA Member?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-52",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 54,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 52,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 18,
                                "ratingItemDescription": "If yes, Provide Membership #",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Membership #",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-54",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If yes, Provide Membership #",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 18,
                                    "ratingItemDescription": "If yes, Provide Membership #",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Membership #",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 55,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 52,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 5,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 17,
                                "ratingItemDescription": "Are you ATA Certified?",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Are you ATA Certified?",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 3,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Boolean",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 12,
                                "uiControl": 12,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-55",
                                "visible": true,
                                "adminVisible": false,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Are you ATA Certified?",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 56,
                                        "programEnrollmentRatingGroupId": 10,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 55,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 6,
                                        "displaySequence": 6,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9998,
                                        "ratingItemDescription": "Yes",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Are you ATA Certified?",
                                        "overrideDescription": "Yes",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-10-56",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Yes",
                                        "relatedItems": [
                                            {
                                                "programEnrollmentRatingItemId": 58,
                                                "programEnrollmentRatingGroupId": 10,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 56,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 6,
                                                "displaySequence": 8,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 19,
                                                "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Language Pairs",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 2,
                                                "uiControl": 2,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-10-58",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "If Yes, Provide Language Pairs:",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 19,
                                                    "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Language Pairs",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            }
                                        ],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9998,
                                            "ratingItemDescription": "Yes",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": true,
                                        "intrinsicValue": null,
                                        "businessName": "Yes",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 57,
                                        "programEnrollmentRatingGroupId": 10,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 55,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 6,
                                        "displaySequence": 7,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9999,
                                        "ratingItemDescription": "No",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Are you ATA Certified?",
                                        "overrideDescription": "No",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-10-57",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "No",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9999,
                                            "ratingItemDescription": "No",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "No",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 17,
                                    "ratingItemDescription": "Are you ATA Certified?",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Are you ATA Certified?",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                                "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 53,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 51,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you an ATA Member?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-53",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 53,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 51,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you an ATA Member?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-53",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 54,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 52,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 18,
                        "ratingItemDescription": "If yes, Provide Membership #",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Membership #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-54",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If yes, Provide Membership #",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 18,
                            "ratingItemDescription": "If yes, Provide Membership #",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Membership #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 54,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 52,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 18,
                        "ratingItemDescription": "If yes, Provide Membership #",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Membership #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-54",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If yes, Provide Membership #",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 18,
                            "ratingItemDescription": "If yes, Provide Membership #",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Membership #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 54,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 52,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 18,
                        "ratingItemDescription": "If yes, Provide Membership #",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Membership #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-54",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If yes, Provide Membership #",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 18,
                            "ratingItemDescription": "If yes, Provide Membership #",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Membership #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 55,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 52,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 17,
                        "ratingItemDescription": "Are you ATA Certified?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Are you ATA Certified?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-55",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Are you ATA Certified?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 56,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 55,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you ATA Certified?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-56",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 58,
                                        "programEnrollmentRatingGroupId": 10,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 56,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 6,
                                        "displaySequence": 8,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 19,
                                        "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Language Pairs",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-10-58",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "If Yes, Provide Language Pairs:",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 19,
                                            "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Language Pairs",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 57,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 55,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 7,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you ATA Certified?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-57",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 17,
                            "ratingItemDescription": "Are you ATA Certified?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Are you ATA Certified?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 55,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 52,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 17,
                        "ratingItemDescription": "Are you ATA Certified?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Are you ATA Certified?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-55",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Are you ATA Certified?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 56,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 55,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you ATA Certified?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-56",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 58,
                                        "programEnrollmentRatingGroupId": 10,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 56,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 6,
                                        "displaySequence": 8,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 19,
                                        "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Language Pairs",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-10-58",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "If Yes, Provide Language Pairs:",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 19,
                                            "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Language Pairs",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 57,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 55,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 7,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you ATA Certified?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-57",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 17,
                            "ratingItemDescription": "Are you ATA Certified?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Are you ATA Certified?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 55,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 52,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 17,
                        "ratingItemDescription": "Are you ATA Certified?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Are you ATA Certified?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-55",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Are you ATA Certified?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 56,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 55,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you ATA Certified?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-56",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 58,
                                        "programEnrollmentRatingGroupId": 10,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 56,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 6,
                                        "displaySequence": 8,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 19,
                                        "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Language Pairs",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-10-58",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "If Yes, Provide Language Pairs:",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 19,
                                            "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Language Pairs",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 57,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 55,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 7,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you ATA Certified?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-57",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 17,
                            "ratingItemDescription": "Are you ATA Certified?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Are you ATA Certified?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 56,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 55,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you ATA Certified?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-56",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 58,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 56,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 8,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 19,
                                "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Language Pairs",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-58",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If Yes, Provide Language Pairs:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 19,
                                    "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Language Pairs",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 56,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 55,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you ATA Certified?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-56",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 58,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 56,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 8,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 19,
                                "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Language Pairs",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-58",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If Yes, Provide Language Pairs:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 19,
                                    "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Language Pairs",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 56,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 55,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you ATA Certified?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-56",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 58,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 56,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 8,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 19,
                                "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Language Pairs",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-58",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If Yes, Provide Language Pairs:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 19,
                                    "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Language Pairs",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 56,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 55,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you ATA Certified?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-56",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 58,
                                "programEnrollmentRatingGroupId": 10,
                                "programEnrollmentId": 4,
                                "parentItemId": 56,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 6,
                                "displaySequence": 8,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 19,
                                "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Language Pairs",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-10-58",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If Yes, Provide Language Pairs:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 19,
                                    "ratingItemDescription": "If Yes, Provide Language Pairs:",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Language Pairs",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 57,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 55,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you ATA Certified?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-57",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 57,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 55,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you ATA Certified?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-57",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 57,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 55,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you ATA Certified?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-57",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 57,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 55,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you ATA Certified?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-57",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 58,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 56,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 19,
                        "ratingItemDescription": "If Yes, Provide Language Pairs:",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Language Pairs",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-58",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, Provide Language Pairs:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 19,
                            "ratingItemDescription": "If Yes, Provide Language Pairs:",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Language Pairs",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 58,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 56,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 19,
                        "ratingItemDescription": "If Yes, Provide Language Pairs:",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Language Pairs",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-58",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, Provide Language Pairs:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 19,
                            "ratingItemDescription": "If Yes, Provide Language Pairs:",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Language Pairs",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 58,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 56,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 19,
                        "ratingItemDescription": "If Yes, Provide Language Pairs:",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Language Pairs",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-58",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, Provide Language Pairs:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 19,
                            "ratingItemDescription": "If Yes, Provide Language Pairs:",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Language Pairs",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 58,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 56,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 19,
                        "ratingItemDescription": "If Yes, Provide Language Pairs:",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Language Pairs",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-58",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, Provide Language Pairs:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 19,
                            "ratingItemDescription": "If Yes, Provide Language Pairs:",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Language Pairs",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 58,
                        "programEnrollmentRatingGroupId": 10,
                        "programEnrollmentId": 4,
                        "parentItemId": 56,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 6,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 19,
                        "ratingItemDescription": "If Yes, Provide Language Pairs:",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Language Pairs",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-10-58",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, Provide Language Pairs:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 19,
                            "ratingItemDescription": "If Yes, Provide Language Pairs:",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Language Pairs",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [
                    {
                        "programEnrollmentRatingGroupContentId": 22,
                        "displaySequence": 1,
                        "content": "<strong>( *Membership is required to bind coverage in the ATA program. However, a premium quotation will be provided subject to receipt of membership information. If you have applied for membership, type in “pending” in the space provided for membership number.",
                        "contentSectionTypeId": 2,
                        "contentSectionType": "Body",
                        "programEnrollmentRatingGroupId": 10,
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:54.2477132",
                        "lastUpdatedUser": null,
                        "lastUpdatedDate": null,
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingGroupContentId": 23,
                        "displaySequence": 2,
                        "content": "<strong>  For details please visit: <a target='_blank' href='https://www.atanet.org/kiosk/nm_signup_pub.pl'>ATANet.Org</a> )</strong>",
                        "contentSectionTypeId": 2,
                        "contentSectionType": "Body",
                        "programEnrollmentRatingGroupId": 10,
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:54.2477132",
                        "lastUpdatedUser": null,
                        "lastUpdatedDate": null,
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 11,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 7,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "What is your employment status?",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 189,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 0,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": 1,
                        "maxSelection": 1,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9995,
                        "ratingItemDescription": "Top level item of a selection (Parent)",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Employment Status",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 0,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "None",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 5,
                        "uiControl": 5,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-189",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "What is your employment status?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 59,
                                "programEnrollmentRatingGroupId": 11,
                                "programEnrollmentId": 4,
                                "parentItemId": 189,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 7,
                                "displaySequence": 1,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 20,
                                "ratingItemDescription": "Full time private sector employee",
                                "ratingGroupDescription": "What is your employment status?",
                                "parentRatingItemDescription": "Employment Status",
                                "overrideDescription": "Full time private sector employee",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-11-59",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Full time private sector employee",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 20,
                                    "ratingItemDescription": "Full time private sector employee",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Full time private sector employee",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 60,
                                "programEnrollmentRatingGroupId": 11,
                                "programEnrollmentId": 4,
                                "parentItemId": 189,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 7,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 21,
                                "ratingItemDescription": "Full time independent contractor",
                                "ratingGroupDescription": "What is your employment status?",
                                "parentRatingItemDescription": "Employment Status",
                                "overrideDescription": "Full time independent contractor",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-11-60",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Full time independent contractor",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 21,
                                    "ratingItemDescription": "Full time independent contractor",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Full time independent contractor",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 61,
                                "programEnrollmentRatingGroupId": 11,
                                "programEnrollmentId": 4,
                                "parentItemId": 189,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 7,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 22,
                                "ratingItemDescription": "Part time independent contractor",
                                "ratingGroupDescription": "What is your employment status?",
                                "parentRatingItemDescription": "Employment Status",
                                "overrideDescription": "Part time independent contractor",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-11-61",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Part time independent contractor",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 22,
                                    "ratingItemDescription": "Part time independent contractor",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Part time independent contractor",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 62,
                                "programEnrollmentRatingGroupId": 11,
                                "programEnrollmentId": 4,
                                "parentItemId": 189,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 7,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 23,
                                "ratingItemDescription": "Company Owner",
                                "ratingGroupDescription": "What is your employment status?",
                                "parentRatingItemDescription": "Employment Status",
                                "overrideDescription": "Company Owner",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-11-62",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Company Owner",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 23,
                                    "ratingItemDescription": "Company Owner",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Company Owner",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 63,
                                "programEnrollmentRatingGroupId": 11,
                                "programEnrollmentId": 4,
                                "parentItemId": 189,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 7,
                                "displaySequence": 5,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 24,
                                "ratingItemDescription": "Government Employee",
                                "ratingGroupDescription": "What is your employment status?",
                                "parentRatingItemDescription": "Employment Status",
                                "overrideDescription": "Government Employee",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-11-63",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Government Employee",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 24,
                                    "ratingItemDescription": "Government Employee",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Government Employee",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 64,
                                "programEnrollmentRatingGroupId": 11,
                                "programEnrollmentId": 4,
                                "parentItemId": 189,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 7,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 25,
                                "ratingItemDescription": "Academia",
                                "ratingGroupDescription": "What is your employment status?",
                                "parentRatingItemDescription": "Employment Status",
                                "overrideDescription": "Academia",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-11-64",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Academia",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 25,
                                    "ratingItemDescription": "Academia",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Academia",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9995,
                            "ratingItemDescription": "Top level item of a selection (Parent)",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Employment Status",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 59,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 20,
                        "ratingItemDescription": "Full time private sector employee",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Full time private sector employee",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-59",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Full time private sector employee",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 20,
                            "ratingItemDescription": "Full time private sector employee",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Full time private sector employee",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 59,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 20,
                        "ratingItemDescription": "Full time private sector employee",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Full time private sector employee",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-59",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Full time private sector employee",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 20,
                            "ratingItemDescription": "Full time private sector employee",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Full time private sector employee",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 60,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 21,
                        "ratingItemDescription": "Full time independent contractor",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Full time independent contractor",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-60",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Full time independent contractor",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 21,
                            "ratingItemDescription": "Full time independent contractor",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Full time independent contractor",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 60,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 21,
                        "ratingItemDescription": "Full time independent contractor",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Full time independent contractor",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-60",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Full time independent contractor",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 21,
                            "ratingItemDescription": "Full time independent contractor",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Full time independent contractor",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 61,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 22,
                        "ratingItemDescription": "Part time independent contractor",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Part time independent contractor",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-61",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Part time independent contractor",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 22,
                            "ratingItemDescription": "Part time independent contractor",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Part time independent contractor",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 61,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 22,
                        "ratingItemDescription": "Part time independent contractor",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Part time independent contractor",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-61",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Part time independent contractor",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 22,
                            "ratingItemDescription": "Part time independent contractor",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Part time independent contractor",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 62,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 23,
                        "ratingItemDescription": "Company Owner",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Company Owner",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-62",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Company Owner",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 23,
                            "ratingItemDescription": "Company Owner",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Company Owner",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 62,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 23,
                        "ratingItemDescription": "Company Owner",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Company Owner",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-62",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Company Owner",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 23,
                            "ratingItemDescription": "Company Owner",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Company Owner",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 63,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 24,
                        "ratingItemDescription": "Government Employee",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Government Employee",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-63",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Government Employee",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 24,
                            "ratingItemDescription": "Government Employee",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Government Employee",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 63,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 24,
                        "ratingItemDescription": "Government Employee",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Government Employee",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-63",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Government Employee",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 24,
                            "ratingItemDescription": "Government Employee",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Government Employee",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 64,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 25,
                        "ratingItemDescription": "Academia",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Academia",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-64",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Academia",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 25,
                            "ratingItemDescription": "Academia",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Academia",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 64,
                        "programEnrollmentRatingGroupId": 11,
                        "programEnrollmentId": 4,
                        "parentItemId": 189,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 7,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 25,
                        "ratingItemDescription": "Academia",
                        "ratingGroupDescription": "What is your employment status?",
                        "parentRatingItemDescription": "Employment Status",
                        "overrideDescription": "Academia",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-11-64",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Academia",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 25,
                            "ratingItemDescription": "Academia",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Academia",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 12,
                "programEnrollmentId": 4,
                "ratingType": 1,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 1,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Income",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "Premium",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 65,
                        "programEnrollmentRatingGroupId": 12,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 1,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": true,
                        "ratingItemId": 26,
                        "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                        "ratingGroupDescription": "Income",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Gross Income",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 1,
                        "ratingType": 12,
                        "groupRatingType": 1,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-12-65",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": "$0.00",
                        "mask": "currency",
                        "className": null,
                        "display": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 26,
                            "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Gross Income",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 13,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 8,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 190,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 0,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": 1,
                        "maxSelection": 5,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9995,
                        "ratingItemDescription": "Top level item of a selection (Parent)",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "% of split of type(s) of services",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 0,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "None",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 10,
                        "uiControl": 10,
                        "uiControlAggregateFunctionId": 1,
                        "uiControlAggregateFunction": 1,
                        "stringUiControlAggregateFunction": "Sum",
                        "validationTargetValue": "100",
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-190",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 66,
                                "programEnrollmentRatingGroupId": 13,
                                "programEnrollmentId": 4,
                                "parentItemId": 190,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 8,
                                "displaySequence": 1,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 27,
                                "ratingItemDescription": "% Editing",
                                "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of type(s) of services",
                                "overrideDescription": "% Editing",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-13-66",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Editing",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 27,
                                    "ratingItemDescription": "% Editing",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Editing",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 67,
                                "programEnrollmentRatingGroupId": 13,
                                "programEnrollmentId": 4,
                                "parentItemId": 190,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 8,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 28,
                                "ratingItemDescription": "% Interpreting",
                                "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of type(s) of services",
                                "overrideDescription": "% Interpreting",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-13-67",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Interpreting",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 28,
                                    "ratingItemDescription": "% Interpreting",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Interpreting",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 68,
                                "programEnrollmentRatingGroupId": 13,
                                "programEnrollmentId": 4,
                                "parentItemId": 190,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 8,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 29,
                                "ratingItemDescription": "% Proofreading",
                                "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of type(s) of services",
                                "overrideDescription": "% Proofreading",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-13-68",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Proofreading",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 29,
                                    "ratingItemDescription": "% Proofreading",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Proofreading",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 69,
                                "programEnrollmentRatingGroupId": 13,
                                "programEnrollmentId": 4,
                                "parentItemId": 190,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 8,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 30,
                                "ratingItemDescription": "% Translating",
                                "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of type(s) of services",
                                "overrideDescription": "% Translating",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-13-69",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Translating",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 30,
                                    "ratingItemDescription": "% Translating",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Translating",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 70,
                                "programEnrollmentRatingGroupId": 13,
                                "programEnrollmentId": 4,
                                "parentItemId": 190,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 8,
                                "displaySequence": 5,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 31,
                                "ratingItemDescription": "% Other",
                                "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of type(s) of services",
                                "overrideDescription": "% Other",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-13-70",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Other",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 185,
                                        "programEnrollmentRatingGroupId": 13,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 70,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 8,
                                        "displaySequence": 6,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 1500,
                                        "ratingItemDescription": "Please describe: ",
                                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                                        "parentRatingItemDescription": "% Other",
                                        "overrideDescription": "Please describe:",
                                        "parentRatingType": 12,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-13-185",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Please describe:",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 1500,
                                            "ratingItemDescription": "Please describe: ",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Please describe:",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 31,
                                    "ratingItemDescription": "% Other",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "% Other",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9995,
                            "ratingItemDescription": "Top level item of a selection (Parent)",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "% of split of type(s) of services",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 66,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 27,
                        "ratingItemDescription": "% Editing",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Editing",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-66",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Editing",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 27,
                            "ratingItemDescription": "% Editing",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Editing",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 66,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 27,
                        "ratingItemDescription": "% Editing",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Editing",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-66",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Editing",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 27,
                            "ratingItemDescription": "% Editing",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Editing",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 67,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 28,
                        "ratingItemDescription": "% Interpreting",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Interpreting",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-67",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Interpreting",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 28,
                            "ratingItemDescription": "% Interpreting",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Interpreting",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 67,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 28,
                        "ratingItemDescription": "% Interpreting",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Interpreting",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-67",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Interpreting",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 28,
                            "ratingItemDescription": "% Interpreting",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Interpreting",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 68,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 29,
                        "ratingItemDescription": "% Proofreading",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Proofreading",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-68",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Proofreading",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 29,
                            "ratingItemDescription": "% Proofreading",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Proofreading",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 68,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 29,
                        "ratingItemDescription": "% Proofreading",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Proofreading",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-68",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Proofreading",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 29,
                            "ratingItemDescription": "% Proofreading",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Proofreading",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 69,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 30,
                        "ratingItemDescription": "% Translating",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Translating",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-69",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Translating",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 30,
                            "ratingItemDescription": "% Translating",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Translating",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 69,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 30,
                        "ratingItemDescription": "% Translating",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Translating",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-69",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Translating",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 30,
                            "ratingItemDescription": "% Translating",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Translating",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 70,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 31,
                        "ratingItemDescription": "% Other",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Other",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-70",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Other",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 185,
                                "programEnrollmentRatingGroupId": 13,
                                "programEnrollmentId": 4,
                                "parentItemId": 70,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 8,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 1500,
                                "ratingItemDescription": "Please describe: ",
                                "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% Other",
                                "overrideDescription": "Please describe:",
                                "parentRatingType": 12,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-13-185",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Please describe:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 1500,
                                    "ratingItemDescription": "Please describe: ",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Please describe:",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 31,
                            "ratingItemDescription": "% Other",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "% Other",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 70,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 190,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 31,
                        "ratingItemDescription": "% Other",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of type(s) of services",
                        "overrideDescription": "% Other",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-70",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Other",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 185,
                                "programEnrollmentRatingGroupId": 13,
                                "programEnrollmentId": 4,
                                "parentItemId": 70,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 8,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 1500,
                                "ratingItemDescription": "Please describe: ",
                                "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% Other",
                                "overrideDescription": "Please describe:",
                                "parentRatingType": 12,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-13-185",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Please describe:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 1500,
                                    "ratingItemDescription": "Please describe: ",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Please describe:",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 31,
                            "ratingItemDescription": "% Other",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "% Other",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 185,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 70,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 1500,
                        "ratingItemDescription": "Please describe: ",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% Other",
                        "overrideDescription": "Please describe:",
                        "parentRatingType": 12,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-185",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Please describe:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 1500,
                            "ratingItemDescription": "Please describe: ",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Please describe:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 185,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 70,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 1500,
                        "ratingItemDescription": "Please describe: ",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% Other",
                        "overrideDescription": "Please describe:",
                        "parentRatingType": 12,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-185",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Please describe:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 1500,
                            "ratingItemDescription": "Please describe: ",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Please describe:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 185,
                        "programEnrollmentRatingGroupId": 13,
                        "programEnrollmentId": 4,
                        "parentItemId": 70,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 8,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 1500,
                        "ratingItemDescription": "Please describe: ",
                        "ratingGroupDescription": "Please indicate approximate % of split of type(s) of services you provide: (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% Other",
                        "overrideDescription": "Please describe:",
                        "parentRatingType": 12,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-13-185",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Please describe:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 1500,
                            "ratingItemDescription": "Please describe: ",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Please describe:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 14,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 9,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 191,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 0,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": 1,
                        "maxSelection": 10,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9995,
                        "ratingItemDescription": "Top level item of a selection (Parent)",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "% of split of services by discipline",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 0,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "None",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 10,
                        "uiControl": 10,
                        "uiControlAggregateFunctionId": 1,
                        "uiControlAggregateFunction": 1,
                        "stringUiControlAggregateFunction": "Sum",
                        "validationTargetValue": "100",
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-191",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 71,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 1,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 32,
                                "ratingItemDescription": "% Arts & Humanities",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Arts & Humanities",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-71",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Arts & Humanities",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 32,
                                    "ratingItemDescription": "% Arts & Humanities",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Arts & Humanities",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 72,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 33,
                                "ratingItemDescription": "% Business",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Business",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-72",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Business",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 33,
                                    "ratingItemDescription": "% Business",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Business",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 73,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 34,
                                "ratingItemDescription": "% Computers",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Computers",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-73",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Computers",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 34,
                                    "ratingItemDescription": "% Computers",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Computers",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 74,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 35,
                                "ratingItemDescription": "% Engineering",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Engineering",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-74",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Engineering",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 35,
                                    "ratingItemDescription": "% Engineering",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Engineering",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 75,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 5,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 36,
                                "ratingItemDescription": "% Medicine",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Medicine",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-75",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Medicine",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 36,
                                    "ratingItemDescription": "% Medicine",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Medicine",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 76,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 37,
                                "ratingItemDescription": "% Social Science",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Social Science",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-76",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Social Science",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 37,
                                    "ratingItemDescription": "% Social Science",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Social Science",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 77,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 7,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 38,
                                "ratingItemDescription": "% Industry & Technology",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Industry & Technology",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-77",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Industry & Technology",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 38,
                                    "ratingItemDescription": "% Industry & Technology",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Industry & Technology",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 78,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 8,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 39,
                                "ratingItemDescription": "% Science",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Science",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-78",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Science",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 39,
                                    "ratingItemDescription": "% Science",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Science",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 79,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 9,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 40,
                                "ratingItemDescription": "% Law",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Law",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-79",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Law",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 40,
                                    "ratingItemDescription": "% Law",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "% Law",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 80,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 191,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 10,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 31,
                                "ratingItemDescription": "% Other",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% of split of services by discipline",
                                "overrideDescription": "% Other",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-80",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "% Other",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 186,
                                        "programEnrollmentRatingGroupId": 14,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 80,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 9,
                                        "displaySequence": 11,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 1500,
                                        "ratingItemDescription": "Please describe: ",
                                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                        "parentRatingItemDescription": "% Other",
                                        "overrideDescription": "Please describe:",
                                        "parentRatingType": 12,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-14-186",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Please describe:",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 1500,
                                            "ratingItemDescription": "Please describe: ",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Please describe:",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 31,
                                    "ratingItemDescription": "% Other",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "% Other",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9995,
                            "ratingItemDescription": "Top level item of a selection (Parent)",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "% of split of services by discipline",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 71,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 32,
                        "ratingItemDescription": "% Arts & Humanities",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Arts & Humanities",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-71",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Arts & Humanities",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 32,
                            "ratingItemDescription": "% Arts & Humanities",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Arts & Humanities",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 71,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 32,
                        "ratingItemDescription": "% Arts & Humanities",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Arts & Humanities",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-71",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Arts & Humanities",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 32,
                            "ratingItemDescription": "% Arts & Humanities",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Arts & Humanities",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 72,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 33,
                        "ratingItemDescription": "% Business",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Business",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-72",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Business",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 33,
                            "ratingItemDescription": "% Business",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Business",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 72,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 33,
                        "ratingItemDescription": "% Business",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Business",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-72",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Business",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 33,
                            "ratingItemDescription": "% Business",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Business",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 73,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 34,
                        "ratingItemDescription": "% Computers",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Computers",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-73",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Computers",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 34,
                            "ratingItemDescription": "% Computers",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Computers",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 73,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 34,
                        "ratingItemDescription": "% Computers",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Computers",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-73",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Computers",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 34,
                            "ratingItemDescription": "% Computers",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Computers",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 74,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 35,
                        "ratingItemDescription": "% Engineering",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Engineering",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-74",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Engineering",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 35,
                            "ratingItemDescription": "% Engineering",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Engineering",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 74,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 35,
                        "ratingItemDescription": "% Engineering",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Engineering",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-74",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Engineering",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 35,
                            "ratingItemDescription": "% Engineering",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Engineering",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 75,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 36,
                        "ratingItemDescription": "% Medicine",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Medicine",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-75",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Medicine",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 36,
                            "ratingItemDescription": "% Medicine",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Medicine",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 75,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 36,
                        "ratingItemDescription": "% Medicine",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Medicine",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-75",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Medicine",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 36,
                            "ratingItemDescription": "% Medicine",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Medicine",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 76,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 37,
                        "ratingItemDescription": "% Social Science",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Social Science",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-76",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Social Science",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 37,
                            "ratingItemDescription": "% Social Science",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Social Science",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 76,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 37,
                        "ratingItemDescription": "% Social Science",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Social Science",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-76",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Social Science",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 37,
                            "ratingItemDescription": "% Social Science",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Social Science",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 77,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 38,
                        "ratingItemDescription": "% Industry & Technology",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Industry & Technology",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-77",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Industry & Technology",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 38,
                            "ratingItemDescription": "% Industry & Technology",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Industry & Technology",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 77,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 38,
                        "ratingItemDescription": "% Industry & Technology",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Industry & Technology",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-77",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Industry & Technology",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 38,
                            "ratingItemDescription": "% Industry & Technology",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Industry & Technology",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 78,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 39,
                        "ratingItemDescription": "% Science",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Science",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-78",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Science",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 39,
                            "ratingItemDescription": "% Science",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Science",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 78,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 39,
                        "ratingItemDescription": "% Science",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Science",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-78",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Science",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 39,
                            "ratingItemDescription": "% Science",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Science",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 79,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 9,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 40,
                        "ratingItemDescription": "% Law",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Law",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-79",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Law",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 40,
                            "ratingItemDescription": "% Law",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Law",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 79,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 9,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 40,
                        "ratingItemDescription": "% Law",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Law",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-79",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Law",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 40,
                            "ratingItemDescription": "% Law",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "% Law",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 80,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 10,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 31,
                        "ratingItemDescription": "% Other",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Other",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-80",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Other",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 186,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 80,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 11,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 1500,
                                "ratingItemDescription": "Please describe: ",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% Other",
                                "overrideDescription": "Please describe:",
                                "parentRatingType": 12,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-186",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Please describe:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 1500,
                                    "ratingItemDescription": "Please describe: ",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Please describe:",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 31,
                            "ratingItemDescription": "% Other",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "% Other",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 80,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 191,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 10,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 31,
                        "ratingItemDescription": "% Other",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% of split of services by discipline",
                        "overrideDescription": "% Other",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-80",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "% Other",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 186,
                                "programEnrollmentRatingGroupId": 14,
                                "programEnrollmentId": 4,
                                "parentItemId": 80,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 9,
                                "displaySequence": 11,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 1500,
                                "ratingItemDescription": "Please describe: ",
                                "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                                "parentRatingItemDescription": "% Other",
                                "overrideDescription": "Please describe:",
                                "parentRatingType": 12,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-14-186",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Please describe:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 1500,
                                    "ratingItemDescription": "Please describe: ",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Please describe:",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 31,
                            "ratingItemDescription": "% Other",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "% Other",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 186,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 80,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 11,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 1500,
                        "ratingItemDescription": "Please describe: ",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% Other",
                        "overrideDescription": "Please describe:",
                        "parentRatingType": 12,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-186",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Please describe:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 1500,
                            "ratingItemDescription": "Please describe: ",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Please describe:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 186,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 80,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 11,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 1500,
                        "ratingItemDescription": "Please describe: ",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% Other",
                        "overrideDescription": "Please describe:",
                        "parentRatingType": 12,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-186",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Please describe:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 1500,
                            "ratingItemDescription": "Please describe: ",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Please describe:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 186,
                        "programEnrollmentRatingGroupId": 14,
                        "programEnrollmentId": 4,
                        "parentItemId": 80,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 9,
                        "displaySequence": 11,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 1500,
                        "ratingItemDescription": "Please describe: ",
                        "ratingGroupDescription": "Please indicate approximate % split of services by discipline (Combined percentage should equal 100%)",
                        "parentRatingItemDescription": "% Other",
                        "overrideDescription": "Please describe:",
                        "parentRatingType": 12,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-14-186",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Please describe:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 1500,
                            "ratingItemDescription": "Please describe: ",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Please describe:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 15,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 10,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 81,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 41,
                        "ratingItemDescription": "Do you subcontract to others?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Do you subcontract to others?",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-81",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Do you subcontract to others?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 82,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 81,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you subcontract to others?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-82",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 84,
                                        "programEnrollmentRatingGroupId": 15,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 82,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 10,
                                        "displaySequence": 4,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 42,
                                        "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Approximate percentage of total income this work represents",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 3,
                                        "ratingType": 12,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeNumeric",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 3,
                                        "uiControl": 3,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-15-84",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "If yes, approximate percentage of total income this work represents:",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 42,
                                            "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Approximate percentage of total income this work represents",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 85,
                                        "programEnrollmentRatingGroupId": 15,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 82,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 10,
                                        "displaySequence": 5,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 43,
                                        "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Percentage of subcontractors with E&O coverage?",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 3,
                                        "ratingType": 12,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeNumeric",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 3,
                                        "uiControl": 3,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-15-85",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "What percentage of your subcontractors carries E&O coverage?",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 43,
                                            "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Percentage of subcontractors with E&O coverage?",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 86,
                                        "programEnrollmentRatingGroupId": 15,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 82,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 10,
                                        "displaySequence": 6,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 44,
                                        "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 3,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Boolean",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 12,
                                        "uiControl": 12,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-15-86",
                                        "visible": true,
                                        "adminVisible": false,
                                        "excludeFromReport": true,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Do you require subcontractors to provide evidence of E&O coverage?",
                                        "relatedItems": [
                                            {
                                                "programEnrollmentRatingItemId": 87,
                                                "programEnrollmentRatingGroupId": 15,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 86,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 10,
                                                "displaySequence": 7,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 9998,
                                                "ratingItemDescription": "Yes",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                                "overrideDescription": "Yes",
                                                "parentRatingType": 3,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 4,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "Selection",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 13,
                                                "uiControl": 13,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-15-87",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Yes",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 9998,
                                                    "ratingItemDescription": "Yes",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Yes",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            },
                                            {
                                                "programEnrollmentRatingItemId": 88,
                                                "programEnrollmentRatingGroupId": 15,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 86,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 10,
                                                "displaySequence": 8,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 9999,
                                                "ratingItemDescription": "No",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                                "overrideDescription": "No",
                                                "parentRatingType": 3,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 4,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "Selection",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 13,
                                                "uiControl": 13,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-15-88",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "No",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 9999,
                                                    "ratingItemDescription": "No",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "No",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            }
                                        ],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 44,
                                            "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": true,
                                        "intrinsicValue": null,
                                        "businessName": "Do you require subcontractors to provide evidence of E&O coverage?",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 83,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 81,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you subcontract to others?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-83",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 41,
                            "ratingItemDescription": "Do you subcontract to others?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Do you subcontract to others?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 82,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 81,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you subcontract to others?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-82",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 84,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 82,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 42,
                                "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Approximate percentage of total income this work represents",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-84",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If yes, approximate percentage of total income this work represents:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 42,
                                    "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Approximate percentage of total income this work represents",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 85,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 82,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 5,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 43,
                                "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Percentage of subcontractors with E&O coverage?",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-85",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "What percentage of your subcontractors carries E&O coverage?",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 43,
                                    "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Percentage of subcontractors with E&O coverage?",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 86,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 82,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 44,
                                "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 3,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Boolean",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 12,
                                "uiControl": 12,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-86",
                                "visible": true,
                                "adminVisible": false,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 87,
                                        "programEnrollmentRatingGroupId": 15,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 86,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 10,
                                        "displaySequence": 7,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9998,
                                        "ratingItemDescription": "Yes",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                        "overrideDescription": "Yes",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-15-87",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Yes",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9998,
                                            "ratingItemDescription": "Yes",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Yes",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 88,
                                        "programEnrollmentRatingGroupId": 15,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 86,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 10,
                                        "displaySequence": 8,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9999,
                                        "ratingItemDescription": "No",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                        "overrideDescription": "No",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-15-88",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "No",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9999,
                                            "ratingItemDescription": "No",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "No",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 44,
                                    "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                                "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 82,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 81,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you subcontract to others?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-82",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 84,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 82,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 42,
                                "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Approximate percentage of total income this work represents",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-84",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If yes, approximate percentage of total income this work represents:",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 42,
                                    "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Approximate percentage of total income this work represents",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 85,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 82,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 5,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 43,
                                "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Percentage of subcontractors with E&O coverage?",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 3,
                                "ratingType": 12,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeNumeric",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 3,
                                "uiControl": 3,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-85",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "What percentage of your subcontractors carries E&O coverage?",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 43,
                                    "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Percentage of subcontractors with E&O coverage?",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 86,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 82,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 44,
                                "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 3,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Boolean",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 12,
                                "uiControl": 12,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-86",
                                "visible": true,
                                "adminVisible": false,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 87,
                                        "programEnrollmentRatingGroupId": 15,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 86,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 10,
                                        "displaySequence": 7,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9998,
                                        "ratingItemDescription": "Yes",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                        "overrideDescription": "Yes",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-15-87",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Yes",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9998,
                                            "ratingItemDescription": "Yes",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Yes",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 88,
                                        "programEnrollmentRatingGroupId": 15,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 86,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 10,
                                        "displaySequence": 8,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9999,
                                        "ratingItemDescription": "No",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                        "overrideDescription": "No",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-15-88",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "No",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9999,
                                            "ratingItemDescription": "No",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "No",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 44,
                                    "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                                "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 83,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 81,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you subcontract to others?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-83",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 83,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 81,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you subcontract to others?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-83",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 84,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 82,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 42,
                        "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Approximate percentage of total income this work represents",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-84",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If yes, approximate percentage of total income this work represents:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 42,
                            "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Approximate percentage of total income this work represents",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 84,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 82,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 42,
                        "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Approximate percentage of total income this work represents",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-84",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If yes, approximate percentage of total income this work represents:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 42,
                            "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Approximate percentage of total income this work represents",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 84,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 82,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 42,
                        "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Approximate percentage of total income this work represents",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-84",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If yes, approximate percentage of total income this work represents:",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 42,
                            "ratingItemDescription": "If yes, approximate percentage of total income this work represents:",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Approximate percentage of total income this work represents",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 85,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 82,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 43,
                        "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Percentage of subcontractors with E&O coverage?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-85",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "What percentage of your subcontractors carries E&O coverage?",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 43,
                            "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Percentage of subcontractors with E&O coverage?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 85,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 82,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 43,
                        "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Percentage of subcontractors with E&O coverage?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-85",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "What percentage of your subcontractors carries E&O coverage?",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 43,
                            "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Percentage of subcontractors with E&O coverage?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 85,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 82,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 43,
                        "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Percentage of subcontractors with E&O coverage?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 3,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-85",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "What percentage of your subcontractors carries E&O coverage?",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 43,
                            "ratingItemDescription": "What percentage of your subcontractors carries E&O coverage?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Percentage of subcontractors with E&O coverage?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 86,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 82,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 44,
                        "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-86",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 87,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 86,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 7,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-87",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 88,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 86,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 8,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-88",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 44,
                            "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 86,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 82,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 44,
                        "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-86",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 87,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 86,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 7,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-87",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 88,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 86,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 8,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-88",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 44,
                            "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 86,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 82,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 44,
                        "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-86",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 87,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 86,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 7,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-87",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 88,
                                "programEnrollmentRatingGroupId": 15,
                                "programEnrollmentId": 4,
                                "parentItemId": 86,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 10,
                                "displaySequence": 8,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-15-88",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 44,
                            "ratingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 87,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 86,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-87",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 87,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 86,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-87",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 87,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 86,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-87",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 87,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 86,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-87",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 88,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 86,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-88",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 88,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 86,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-88",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 88,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 86,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-88",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 88,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": 86,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you require subcontractors to provide evidence of E&O coverage?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-88",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 89,
                        "programEnrollmentRatingGroupId": 15,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 10,
                        "displaySequence": 9,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 45,
                        "ratingItemDescription": "Please provide details of any subcontractors based outside of the USA (if not applicable, state None):",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Details of any subcontractors based outside of the USA:",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-15-89",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Please provide details of any subcontractors based outside of the USA (if not applicable, state None):",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 45,
                            "ratingItemDescription": "Please provide details of any subcontractors based outside of the USA (if not applicable, state None):",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Details of any subcontractors based outside of the USA:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 16,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 11,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 90,
                        "programEnrollmentRatingGroupId": 16,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 11,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 46,
                        "ratingItemDescription": "Do you always use the ATA model contract with each client? If No, attach a template service agreement with all sensitive data and verbiage blocked. If you can’t provide a copy of your client’s contract, please prepare a document that states that you sign your client’s contracts which you will provide should there be a claim.",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Do you always use the ATA model contract with each client?",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-16-90",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Do you always use the ATA model contract with each client? If No, attach a template service agreement with all sensitive data and verbiage blocked. If you can’t provide a copy of your client’s contract, please prepare a document that states that you sign your client’s contracts which you will provide should there be a claim.",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 91,
                                "programEnrollmentRatingGroupId": 16,
                                "programEnrollmentId": 4,
                                "parentItemId": 90,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 11,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you always use the ATA model contract with each client?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-16-91",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 92,
                                "programEnrollmentRatingGroupId": 16,
                                "programEnrollmentId": 4,
                                "parentItemId": 90,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 11,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Do you always use the ATA model contract with each client?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-16-92",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 93,
                                        "programEnrollmentRatingGroupId": 16,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 92,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 11,
                                        "displaySequence": 4,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 47,
                                        "ratingItemDescription": "Attach Contract",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "No",
                                        "overrideDescription": "Attach Contract",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 21,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Attachment",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 7,
                                        "uiControl": 7,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-16-93",
                                        "visible": true,
                                        "adminVisible": false,
                                        "excludeFromReport": true,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "<div>Attach Contract</div><span class='file-size-message'>(The maximum file size for an attachment is 2MB.)</span>",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 47,
                                            "ratingItemDescription": "Attach Contract",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Attach Contract",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 46,
                            "ratingItemDescription": "Do you always use the ATA model contract with each client? If No, attach a template service agreement with all sensitive data and verbiage blocked. If you can’t provide a copy of your client’s contract, please prepare a document that states that you sign your client’s contracts which you will provide should there be a claim.",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Do you always use the ATA model contract with each client?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 91,
                        "programEnrollmentRatingGroupId": 16,
                        "programEnrollmentId": 4,
                        "parentItemId": 90,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 11,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you always use the ATA model contract with each client?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-16-91",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 91,
                        "programEnrollmentRatingGroupId": 16,
                        "programEnrollmentId": 4,
                        "parentItemId": 90,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 11,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you always use the ATA model contract with each client?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-16-91",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 92,
                        "programEnrollmentRatingGroupId": 16,
                        "programEnrollmentId": 4,
                        "parentItemId": 90,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 11,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you always use the ATA model contract with each client?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-16-92",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 93,
                                "programEnrollmentRatingGroupId": 16,
                                "programEnrollmentId": 4,
                                "parentItemId": 92,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 11,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 47,
                                "ratingItemDescription": "Attach Contract",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "No",
                                "overrideDescription": "Attach Contract",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 21,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Attachment",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 7,
                                "uiControl": 7,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-16-93",
                                "visible": true,
                                "adminVisible": false,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Attach Contract",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 47,
                                    "ratingItemDescription": "Attach Contract",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Attach Contract",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                                "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 92,
                        "programEnrollmentRatingGroupId": 16,
                        "programEnrollmentId": 4,
                        "parentItemId": 90,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 11,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Do you always use the ATA model contract with each client?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-16-92",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 93,
                                "programEnrollmentRatingGroupId": 16,
                                "programEnrollmentId": 4,
                                "parentItemId": 92,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 11,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 47,
                                "ratingItemDescription": "Attach Contract",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "No",
                                "overrideDescription": "Attach Contract",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 21,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Attachment",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 7,
                                "uiControl": 7,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-16-93",
                                "visible": true,
                                "adminVisible": false,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Attach Contract",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 47,
                                    "ratingItemDescription": "Attach Contract",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Attach Contract",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                                "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 93,
                        "programEnrollmentRatingGroupId": 16,
                        "programEnrollmentId": 4,
                        "parentItemId": 92,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 11,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 47,
                        "ratingItemDescription": "Attach Contract",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "No",
                        "overrideDescription": "Attach Contract",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 21,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Attachment",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 7,
                        "uiControl": 7,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-16-93",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Attach Contract",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 47,
                            "ratingItemDescription": "Attach Contract",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Attach Contract",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 93,
                        "programEnrollmentRatingGroupId": 16,
                        "programEnrollmentId": 4,
                        "parentItemId": 92,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 11,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 47,
                        "ratingItemDescription": "Attach Contract",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "No",
                        "overrideDescription": "Attach Contract",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 21,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Attachment",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 7,
                        "uiControl": 7,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-16-93",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Attach Contract",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 47,
                            "ratingItemDescription": "Attach Contract",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Attach Contract",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 93,
                        "programEnrollmentRatingGroupId": 16,
                        "programEnrollmentId": 4,
                        "parentItemId": 92,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 11,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 47,
                        "ratingItemDescription": "Attach Contract",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "No",
                        "overrideDescription": "Attach Contract",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 21,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Attachment",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 7,
                        "uiControl": 7,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-16-93",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Attach Contract",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 47,
                            "ratingItemDescription": "Attach Contract",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Attach Contract",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateProgramEnrollmentRatingItemsVisibiltyOverride",
                        "lastUpdatedDate": "2020-02-05T00:13:58.8484019",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 17,
                "programEnrollmentId": 4,
                "ratingType": 31,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 2,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Limits of liability",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "Factor",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 192,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 0,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": 1,
                        "maxSelection": 1,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9995,
                        "ratingItemDescription": "Top level item of a selection (Parent)",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Limits of liability",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 0,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "None",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 5,
                        "uiControl": 5,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-192",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": "Available limits based on income...",
                        "mask": null,
                        "className": null,
                        "display": "Limits of liability",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 94,
                                "programEnrollmentRatingGroupId": 17,
                                "programEnrollmentId": 4,
                                "parentItemId": 192,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 2,
                                "displaySequence": 1,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0.625,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": 6,
                                "upperLimitCoverageTypeId": 1,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 48,
                                "ratingItemDescription": "$250,000",
                                "ratingGroupDescription": "Limits of liability",
                                "parentRatingItemDescription": "Limits of liability",
                                "overrideDescription": "$250,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-17-94",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$250,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 48,
                                    "ratingItemDescription": "$250,000",
                                    "lowerLimit": 250000,
                                    "upperLimit": 250000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "0.62500000000000000000",
                                "businessName": "$250,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 95,
                                "programEnrollmentRatingGroupId": 17,
                                "programEnrollmentId": 4,
                                "parentItemId": 192,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 2,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0.875,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": 6,
                                "upperLimitCoverageTypeId": 1,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 49,
                                "ratingItemDescription": "$500,000",
                                "ratingGroupDescription": "Limits of liability",
                                "parentRatingItemDescription": "Limits of liability",
                                "overrideDescription": "$500,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-17-95",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$500,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 49,
                                    "ratingItemDescription": "$500,000",
                                    "lowerLimit": 500000,
                                    "upperLimit": 500000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "0.87500000000000000000",
                                "businessName": "$500,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 96,
                                "programEnrollmentRatingGroupId": 17,
                                "programEnrollmentId": 4,
                                "parentItemId": 192,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 2,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 1,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": 6,
                                "upperLimitCoverageTypeId": 1,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 50,
                                "ratingItemDescription": "$1,000,000",
                                "ratingGroupDescription": "Limits of liability",
                                "parentRatingItemDescription": "Limits of liability",
                                "overrideDescription": "$1,000,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-17-96",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$1,000,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 50,
                                    "ratingItemDescription": "$1,000,000",
                                    "lowerLimit": 1000000,
                                    "upperLimit": 1000000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "1.00000000000000000000",
                                "businessName": "$1,000,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 97,
                                "programEnrollmentRatingGroupId": 17,
                                "programEnrollmentId": 4,
                                "parentItemId": 192,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 2,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 1.45,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": 6,
                                "upperLimitCoverageTypeId": 1,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 51,
                                "ratingItemDescription": "$2,000,000",
                                "ratingGroupDescription": "Limits of liability",
                                "parentRatingItemDescription": "Limits of liability",
                                "overrideDescription": "$2,000,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-17-97",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$2,000,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 51,
                                    "ratingItemDescription": "$2,000,000",
                                    "lowerLimit": 2000000,
                                    "upperLimit": 2000000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "1.45000000000000000000",
                                "businessName": "$2,000,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 98,
                                "programEnrollmentRatingGroupId": 17,
                                "programEnrollmentId": 4,
                                "parentItemId": 192,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 2,
                                "displaySequence": 5,
                                "premium": 0,
                                "deductible": null,
                                "factor": 1.2,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": 6,
                                "upperLimitCoverageTypeId": 1,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 70,
                                "ratingItemDescription": "$1,000,000 / $2,000,000",
                                "ratingGroupDescription": "Limits of liability",
                                "parentRatingItemDescription": "Limits of liability",
                                "overrideDescription": "$1,000,000 / $2,000,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-17-98",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$1,000,000 / $2,000,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 70,
                                    "ratingItemDescription": "$1,000,000 / $2,000,000",
                                    "lowerLimit": 1000000,
                                    "upperLimit": 2000000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "1.20000000000000000000",
                                "businessName": "$1,000,000 / $2,000,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 99,
                                "programEnrollmentRatingGroupId": 17,
                                "programEnrollmentId": 4,
                                "parentItemId": 192,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 2,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": null,
                                "factor": 1.35,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": 6,
                                "upperLimitCoverageTypeId": 1,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 71,
                                "ratingItemDescription": "$1,000,000 / $3,000,000",
                                "ratingGroupDescription": "Limits of liability",
                                "parentRatingItemDescription": "Limits of liability",
                                "overrideDescription": "$1,000,000 / $3,000,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-17-99",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$1,000,000 / $3,000,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 71,
                                    "ratingItemDescription": "$1,000,000 / $3,000,000",
                                    "lowerLimit": 1000000,
                                    "upperLimit": 3000000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "1.35000000000000000000",
                                "businessName": "$1,000,000 / $3,000,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 187,
                                "programEnrollmentRatingGroupId": 17,
                                "programEnrollmentId": 4,
                                "parentItemId": 192,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 2,
                                "displaySequence": 7,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": 6,
                                "upperLimitCoverageTypeId": 1,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 78,
                                "ratingItemDescription": "$3,000,000",
                                "ratingGroupDescription": "Limits of liability",
                                "parentRatingItemDescription": "Limits of liability",
                                "overrideDescription": "$3,000,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-17-187",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$3,000,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 78,
                                    "ratingItemDescription": "$3,000,000",
                                    "lowerLimit": 3000000,
                                    "upperLimit": 3000000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "0.00000000000000000000",
                                "businessName": "$3,000,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 188,
                                "programEnrollmentRatingGroupId": 17,
                                "programEnrollmentId": 4,
                                "parentItemId": 192,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 2,
                                "displaySequence": 8,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": 6,
                                "upperLimitCoverageTypeId": 1,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 77,
                                "ratingItemDescription": "$5,000,000",
                                "ratingGroupDescription": "Limits of liability",
                                "parentRatingItemDescription": "Limits of liability",
                                "overrideDescription": "$5,000,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-17-188",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$5,000,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 77,
                                    "ratingItemDescription": "$5,000,000",
                                    "lowerLimit": 5000000,
                                    "upperLimit": 5000000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "0.00000000000000000000",
                                "businessName": "$5,000,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9995,
                            "ratingItemDescription": "Top level item of a selection (Parent)",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Limits of liability",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 94,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0.625,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 48,
                        "ratingItemDescription": "$250,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$250,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-94",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$250,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 48,
                            "ratingItemDescription": "$250,000",
                            "lowerLimit": 250000,
                            "upperLimit": 250000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.62500000000000000000",
                        "businessName": "$250,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 94,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0.625,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 48,
                        "ratingItemDescription": "$250,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$250,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-94",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$250,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 48,
                            "ratingItemDescription": "$250,000",
                            "lowerLimit": 250000,
                            "upperLimit": 250000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.62500000000000000000",
                        "businessName": "$250,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 95,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0.875,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 49,
                        "ratingItemDescription": "$500,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$500,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-95",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$500,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 49,
                            "ratingItemDescription": "$500,000",
                            "lowerLimit": 500000,
                            "upperLimit": 500000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.87500000000000000000",
                        "businessName": "$500,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 95,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0.875,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 49,
                        "ratingItemDescription": "$500,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$500,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-95",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$500,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 49,
                            "ratingItemDescription": "$500,000",
                            "lowerLimit": 500000,
                            "upperLimit": 500000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.87500000000000000000",
                        "businessName": "$500,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 96,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 1,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 50,
                        "ratingItemDescription": "$1,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$1,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-96",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$1,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 50,
                            "ratingItemDescription": "$1,000,000",
                            "lowerLimit": 1000000,
                            "upperLimit": 1000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.00000000000000000000",
                        "businessName": "$1,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 96,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 1,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 50,
                        "ratingItemDescription": "$1,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$1,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-96",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$1,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 50,
                            "ratingItemDescription": "$1,000,000",
                            "lowerLimit": 1000000,
                            "upperLimit": 1000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.00000000000000000000",
                        "businessName": "$1,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 97,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 1.45,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 51,
                        "ratingItemDescription": "$2,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$2,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-97",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$2,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 51,
                            "ratingItemDescription": "$2,000,000",
                            "lowerLimit": 2000000,
                            "upperLimit": 2000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.45000000000000000000",
                        "businessName": "$2,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 97,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 1.45,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 51,
                        "ratingItemDescription": "$2,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$2,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-97",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$2,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 51,
                            "ratingItemDescription": "$2,000,000",
                            "lowerLimit": 2000000,
                            "upperLimit": 2000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.45000000000000000000",
                        "businessName": "$2,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 98,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 1.2,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 70,
                        "ratingItemDescription": "$1,000,000 / $2,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$1,000,000 / $2,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-98",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$1,000,000 / $2,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 70,
                            "ratingItemDescription": "$1,000,000 / $2,000,000",
                            "lowerLimit": 1000000,
                            "upperLimit": 2000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.20000000000000000000",
                        "businessName": "$1,000,000 / $2,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 98,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": null,
                        "factor": 1.2,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 70,
                        "ratingItemDescription": "$1,000,000 / $2,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$1,000,000 / $2,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-98",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$1,000,000 / $2,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 70,
                            "ratingItemDescription": "$1,000,000 / $2,000,000",
                            "lowerLimit": 1000000,
                            "upperLimit": 2000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.20000000000000000000",
                        "businessName": "$1,000,000 / $2,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 99,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 1.35,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 71,
                        "ratingItemDescription": "$1,000,000 / $3,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$1,000,000 / $3,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-99",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$1,000,000 / $3,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 71,
                            "ratingItemDescription": "$1,000,000 / $3,000,000",
                            "lowerLimit": 1000000,
                            "upperLimit": 3000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.35000000000000000000",
                        "businessName": "$1,000,000 / $3,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 99,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": null,
                        "factor": 1.35,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 71,
                        "ratingItemDescription": "$1,000,000 / $3,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$1,000,000 / $3,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-99",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$1,000,000 / $3,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 71,
                            "ratingItemDescription": "$1,000,000 / $3,000,000",
                            "lowerLimit": 1000000,
                            "upperLimit": 3000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.35000000000000000000",
                        "businessName": "$1,000,000 / $3,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 187,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 78,
                        "ratingItemDescription": "$3,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$3,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-187",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$3,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 78,
                            "ratingItemDescription": "$3,000,000",
                            "lowerLimit": 3000000,
                            "upperLimit": 3000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.00000000000000000000",
                        "businessName": "$3,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 187,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 7,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 78,
                        "ratingItemDescription": "$3,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$3,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-187",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$3,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 78,
                            "ratingItemDescription": "$3,000,000",
                            "lowerLimit": 3000000,
                            "upperLimit": 3000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.00000000000000000000",
                        "businessName": "$3,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 188,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 77,
                        "ratingItemDescription": "$5,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$5,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-188",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$5,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 77,
                            "ratingItemDescription": "$5,000,000",
                            "lowerLimit": 5000000,
                            "upperLimit": 5000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.00000000000000000000",
                        "businessName": "$5,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 188,
                        "programEnrollmentRatingGroupId": 17,
                        "programEnrollmentId": 4,
                        "parentItemId": 192,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 2,
                        "displaySequence": 8,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": 6,
                        "upperLimitCoverageTypeId": 1,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 77,
                        "ratingItemDescription": "$5,000,000",
                        "ratingGroupDescription": "Limits of liability",
                        "parentRatingItemDescription": "Limits of liability",
                        "overrideDescription": "$5,000,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-17-188",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$5,000,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 77,
                            "ratingItemDescription": "$5,000,000",
                            "lowerLimit": 5000000,
                            "upperLimit": 5000000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.00000000000000000000",
                        "businessName": "$5,000,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": true,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 18,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 12,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 101,
                        "programEnrollmentRatingGroupId": 18,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 12,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 52,
                        "ratingItemDescription": "Has E&O Coverage ever been declined, canceled or non-renewed for you?",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Has E&O Coverage ever been declined, canceled or non-renewed for you ?",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-18-101",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Has E&O Coverage ever been declined, canceled or non-renewed for you ?",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 102,
                                "programEnrollmentRatingGroupId": 18,
                                "programEnrollmentId": 4,
                                "parentItemId": 101,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 12,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Has E&O Coverage ever been declined, canceled or non-renewed for you ?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-18-102",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 103,
                                "programEnrollmentRatingGroupId": 18,
                                "programEnrollmentId": 4,
                                "parentItemId": 101,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 12,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Has E&O Coverage ever been declined, canceled or non-renewed for you ?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-18-103",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 52,
                            "ratingItemDescription": "Has E&O Coverage ever been declined, canceled or non-renewed for you?",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Has E&O Coverage ever been declined, canceled or non-renewed for you ?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 102,
                        "programEnrollmentRatingGroupId": 18,
                        "programEnrollmentId": 4,
                        "parentItemId": 101,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 12,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Has E&O Coverage ever been declined, canceled or non-renewed for you ?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-18-102",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 102,
                        "programEnrollmentRatingGroupId": 18,
                        "programEnrollmentId": 4,
                        "parentItemId": 101,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 12,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Has E&O Coverage ever been declined, canceled or non-renewed for you ?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-18-102",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 103,
                        "programEnrollmentRatingGroupId": 18,
                        "programEnrollmentId": 4,
                        "parentItemId": 101,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 12,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Has E&O Coverage ever been declined, canceled or non-renewed for you ?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-18-103",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 103,
                        "programEnrollmentRatingGroupId": 18,
                        "programEnrollmentId": 4,
                        "parentItemId": 101,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 12,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Has E&O Coverage ever been declined, canceled or non-renewed for you ?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-18-103",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 19,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 13,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 104,
                        "programEnrollmentRatingGroupId": 19,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 13,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 53,
                        "ratingItemDescription": "Have any claims been made against the applicant or any of your past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions? *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Claims made against the applicant/past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-19-104",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Have any claims been made against the applicant or any of your past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions? *",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 105,
                                "programEnrollmentRatingGroupId": 19,
                                "programEnrollmentId": 4,
                                "parentItemId": 104,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 13,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Claims made against the applicant/past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-19-105",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 107,
                                        "programEnrollmentRatingGroupId": 19,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 105,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 13,
                                        "displaySequence": 4,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 54,
                                        "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-19-107",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 54,
                                            "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 106,
                                "programEnrollmentRatingGroupId": 19,
                                "programEnrollmentId": 4,
                                "parentItemId": 104,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 13,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Claims made against the applicant/past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-19-106",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 53,
                            "ratingItemDescription": "Have any claims been made against the applicant or any of your past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions? *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Claims made against the applicant/past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 105,
                        "programEnrollmentRatingGroupId": 19,
                        "programEnrollmentId": 4,
                        "parentItemId": 104,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 13,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Claims made against the applicant/past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-19-105",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 107,
                                "programEnrollmentRatingGroupId": 19,
                                "programEnrollmentId": 4,
                                "parentItemId": 105,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 13,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 54,
                                "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-19-107",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 54,
                                    "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 105,
                        "programEnrollmentRatingGroupId": 19,
                        "programEnrollmentId": 4,
                        "parentItemId": 104,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 13,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Claims made against the applicant/past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-19-105",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 107,
                                "programEnrollmentRatingGroupId": 19,
                                "programEnrollmentId": 4,
                                "parentItemId": 105,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 13,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 54,
                                "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-19-107",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 54,
                                    "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 106,
                        "programEnrollmentRatingGroupId": 19,
                        "programEnrollmentId": 4,
                        "parentItemId": 104,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 13,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Claims made against the applicant/past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-19-106",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 106,
                        "programEnrollmentRatingGroupId": 19,
                        "programEnrollmentId": 4,
                        "parentItemId": 104,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 13,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Claims made against the applicant/past or present owners, officers, partners, directors, or employees, either individually or otherwise arising out of any negligent acts, errors or omissions",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-19-106",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 107,
                        "programEnrollmentRatingGroupId": 19,
                        "programEnrollmentId": 4,
                        "parentItemId": 105,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 13,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 54,
                        "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-19-107",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 54,
                            "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 107,
                        "programEnrollmentRatingGroupId": 19,
                        "programEnrollmentId": 4,
                        "parentItemId": 105,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 13,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 54,
                        "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-19-107",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 54,
                            "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 107,
                        "programEnrollmentRatingGroupId": 19,
                        "programEnrollmentId": 4,
                        "parentItemId": 105,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 13,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 54,
                        "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-19-107",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 54,
                            "ratingItemDescription": "If Yes, please provide full details including date, claimant’s name(s) and amounts paid for both settlement and defense: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Full details including date, claimant’s name(s) and amounts paid for both settlement and defense:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 20,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 14,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 108,
                        "programEnrollmentRatingGroupId": 20,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 14,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 55,
                        "ratingItemDescription": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim? *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim?",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-20-108",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim? *",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 109,
                                "programEnrollmentRatingGroupId": 20,
                                "programEnrollmentId": 4,
                                "parentItemId": 108,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 14,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-20-109",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 111,
                                        "programEnrollmentRatingGroupId": 20,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 109,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 14,
                                        "displaySequence": 4,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 56,
                                        "ratingItemDescription": "If Yes, please provide details: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Please provide details:",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-20-111",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "If Yes, please provide details: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 56,
                                            "ratingItemDescription": "If Yes, please provide details: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Please provide details:",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 110,
                                "programEnrollmentRatingGroupId": 20,
                                "programEnrollmentId": 4,
                                "parentItemId": 108,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 14,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-20-110",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 55,
                            "ratingItemDescription": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim? *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 109,
                        "programEnrollmentRatingGroupId": 20,
                        "programEnrollmentId": 4,
                        "parentItemId": 108,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 14,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-20-109",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 111,
                                "programEnrollmentRatingGroupId": 20,
                                "programEnrollmentId": 4,
                                "parentItemId": 109,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 14,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 56,
                                "ratingItemDescription": "If Yes, please provide details: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Please provide details:",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-20-111",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If Yes, please provide details: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 56,
                                    "ratingItemDescription": "If Yes, please provide details: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Please provide details:",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 109,
                        "programEnrollmentRatingGroupId": 20,
                        "programEnrollmentId": 4,
                        "parentItemId": 108,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 14,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-20-109",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 111,
                                "programEnrollmentRatingGroupId": 20,
                                "programEnrollmentId": 4,
                                "parentItemId": 109,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 14,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 56,
                                "ratingItemDescription": "If Yes, please provide details: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Please provide details:",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-20-111",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "If Yes, please provide details: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 56,
                                    "ratingItemDescription": "If Yes, please provide details: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Please provide details:",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 110,
                        "programEnrollmentRatingGroupId": 20,
                        "programEnrollmentId": 4,
                        "parentItemId": 108,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 14,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-20-110",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 110,
                        "programEnrollmentRatingGroupId": 20,
                        "programEnrollmentId": 4,
                        "parentItemId": 108,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 14,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Have you or any of your past or present owners, officers, partners, directors or employees, after inquiry; have any knowledge or information of any circumstance whatsoever which might give rise to a claim?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-20-110",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 111,
                        "programEnrollmentRatingGroupId": 20,
                        "programEnrollmentId": 4,
                        "parentItemId": 109,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 14,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 56,
                        "ratingItemDescription": "If Yes, please provide details: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Please provide details:",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-20-111",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, please provide details: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 56,
                            "ratingItemDescription": "If Yes, please provide details: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Please provide details:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 111,
                        "programEnrollmentRatingGroupId": 20,
                        "programEnrollmentId": 4,
                        "parentItemId": 109,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 14,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 56,
                        "ratingItemDescription": "If Yes, please provide details: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Please provide details:",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-20-111",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, please provide details: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 56,
                            "ratingItemDescription": "If Yes, please provide details: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Please provide details:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 111,
                        "programEnrollmentRatingGroupId": 20,
                        "programEnrollmentId": 4,
                        "parentItemId": 109,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 14,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 56,
                        "ratingItemDescription": "If Yes, please provide details: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Please provide details:",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-20-111",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "If Yes, please provide details: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 56,
                            "ratingItemDescription": "If Yes, please provide details: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Please provide details:",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 21,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 4,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 112,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 57,
                        "ratingItemDescription": "Are you currently Insured under the ATA E&O program? *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Are you currently Insured under the ATA E&O program?",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-112",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Are you currently Insured under the ATA E&O program? *",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 113,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 112,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you currently Insured under the ATA E&O program?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-113",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 115,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 113,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 11,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 58,
                                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Retroactive Date",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 6,
                                        "uiControl": 6,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-115",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Retroactive Date (date your policy was effective): *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 58,
                                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Retroactive Date",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 116,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 113,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 12,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 59,
                                        "ratingItemDescription": "Policy #: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Policy #",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-116",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Policy #: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 59,
                                            "ratingItemDescription": "Policy #: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Policy #",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 117,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 113,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 13,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 60,
                                        "ratingItemDescription": "Expiration Date: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Expiration Date",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 6,
                                        "uiControl": 6,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-117",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Expiration Date: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 60,
                                            "ratingItemDescription": "Expiration Date: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Expiration Date",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 114,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 112,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you currently Insured under the ATA E&O program?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-114",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 118,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 114,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 14,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 61,
                                        "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "No",
                                        "overrideDescription": "Are you currently Insured under another E&O program?",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 3,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Boolean",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 12,
                                        "uiControl": 12,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-118",
                                        "visible": true,
                                        "adminVisible": false,
                                        "excludeFromReport": true,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Are you currently Insured under another E&O program? *",
                                        "relatedItems": [
                                            {
                                                "programEnrollmentRatingItemId": 119,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 118,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 15,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 9998,
                                                "ratingItemDescription": "Yes",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                                "overrideDescription": "Yes",
                                                "parentRatingType": 3,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 4,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "Selection",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 13,
                                                "uiControl": 13,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-119",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Yes",
                                                "relatedItems": [
                                                    {
                                                        "programEnrollmentRatingItemId": 121,
                                                        "programEnrollmentRatingGroupId": 21,
                                                        "programEnrollmentId": 4,
                                                        "parentItemId": 119,
                                                        "sectionDisplaySequence": null,
                                                        "groupDisplaySequence": 4,
                                                        "displaySequence": 17,
                                                        "premium": 0,
                                                        "deductible": null,
                                                        "factor": 0,
                                                        "lowerLimit": null,
                                                        "upperLimit": null,
                                                        "lowerStringLimit": null,
                                                        "upperStringLimit": null,
                                                        "minSelection": null,
                                                        "maxSelection": null,
                                                        "lowerLimitCoverageTypeId": null,
                                                        "upperLimitCoverageTypeId": null,
                                                        "agencyFee": null,
                                                        "isFactorable": false,
                                                        "ratingItemId": 59,
                                                        "ratingItemDescription": "Policy #: *",
                                                        "ratingGroupDescription": "",
                                                        "parentRatingItemDescription": "Yes",
                                                        "overrideDescription": "Policy #",
                                                        "parentRatingType": 4,
                                                        "specialInstruction": null,
                                                        "defaultSelectedState": false,
                                                        "value": null,
                                                        "numericDataType": 0,
                                                        "ratingType": 11,
                                                        "groupRatingType": 0,
                                                        "conditional": false,
                                                        "functionType": 0,
                                                        "stringFunctionType": "None",
                                                        "programEnrollmentDocumentId": null,
                                                        "programEnrollmentDocument": null,
                                                        "stringRatingType": "FreeText",
                                                        "minPremium": null,
                                                        "maxPremium": null,
                                                        "uiIsRequired": null,
                                                        "uiIsReadonly": null,
                                                        "uiControlId": 2,
                                                        "uiControl": 2,
                                                        "uiControlAggregateFunctionId": null,
                                                        "uiControlAggregateFunction": 0,
                                                        "stringUiControlAggregateFunction": "None",
                                                        "validationTargetValue": null,
                                                        "validationTargetItemId": null,
                                                        "sectionId": null,
                                                        "sectionName": null,
                                                        "sectionIndicator": false,
                                                        "uniqueIdentifier": "4-21-121",
                                                        "visible": true,
                                                        "adminVisible": true,
                                                        "excludeFromReport": false,
                                                        "semanticItemId": null,
                                                        "semanticParentItemId": null,
                                                        "hint": null,
                                                        "placeHolder": null,
                                                        "mask": null,
                                                        "className": null,
                                                        "display": "Policy #: *",
                                                        "relatedItems": [],
                                                        "isDefault": false,
                                                        "ratingItem": {
                                                            "ratingItemId": 59,
                                                            "ratingItemDescription": "Policy #: *",
                                                            "lowerLimit": null,
                                                            "upperLimit": null,
                                                            "createUser": "Migration.Seeder",
                                                            "createDate": "2020-02-05T00:05:03.7219203",
                                                            "lastUpdatedUser": null,
                                                            "lastUpdatedDate": null,
                                                            "disabled": false,
                                                            "systemNotes": null,
                                                            "userEmail": null,
                                                            "errors": [],
                                                            "isSuccessful": true
                                                        },
                                                        "hasChildren": false,
                                                        "intrinsicValue": null,
                                                        "businessName": "Policy #",
                                                        "createUser": "Migration.Seeder",
                                                        "createDate": "2020-02-05T00:05:25.7004791",
                                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                                        "disabled": false,
                                                        "systemNotes": null,
                                                        "userEmail": null,
                                                        "errors": [],
                                                        "isSuccessful": true
                                                    },
                                                    {
                                                        "programEnrollmentRatingItemId": 122,
                                                        "programEnrollmentRatingGroupId": 21,
                                                        "programEnrollmentId": 4,
                                                        "parentItemId": 119,
                                                        "sectionDisplaySequence": null,
                                                        "groupDisplaySequence": 4,
                                                        "displaySequence": 18,
                                                        "premium": 0,
                                                        "deductible": null,
                                                        "factor": 0,
                                                        "lowerLimit": null,
                                                        "upperLimit": null,
                                                        "lowerStringLimit": null,
                                                        "upperStringLimit": null,
                                                        "minSelection": null,
                                                        "maxSelection": null,
                                                        "lowerLimitCoverageTypeId": null,
                                                        "upperLimitCoverageTypeId": null,
                                                        "agencyFee": null,
                                                        "isFactorable": false,
                                                        "ratingItemId": 60,
                                                        "ratingItemDescription": "Expiration Date: *",
                                                        "ratingGroupDescription": "",
                                                        "parentRatingItemDescription": "Yes",
                                                        "overrideDescription": "Expiration Date",
                                                        "parentRatingType": 4,
                                                        "specialInstruction": null,
                                                        "defaultSelectedState": false,
                                                        "value": null,
                                                        "numericDataType": 0,
                                                        "ratingType": 11,
                                                        "groupRatingType": 0,
                                                        "conditional": false,
                                                        "functionType": 0,
                                                        "stringFunctionType": "None",
                                                        "programEnrollmentDocumentId": null,
                                                        "programEnrollmentDocument": null,
                                                        "stringRatingType": "FreeText",
                                                        "minPremium": null,
                                                        "maxPremium": null,
                                                        "uiIsRequired": null,
                                                        "uiIsReadonly": null,
                                                        "uiControlId": 6,
                                                        "uiControl": 6,
                                                        "uiControlAggregateFunctionId": null,
                                                        "uiControlAggregateFunction": 0,
                                                        "stringUiControlAggregateFunction": "None",
                                                        "validationTargetValue": null,
                                                        "validationTargetItemId": null,
                                                        "sectionId": null,
                                                        "sectionName": null,
                                                        "sectionIndicator": false,
                                                        "uniqueIdentifier": "4-21-122",
                                                        "visible": true,
                                                        "adminVisible": true,
                                                        "excludeFromReport": false,
                                                        "semanticItemId": null,
                                                        "semanticParentItemId": null,
                                                        "hint": null,
                                                        "placeHolder": null,
                                                        "mask": null,
                                                        "className": null,
                                                        "display": "Expiration Date: *",
                                                        "relatedItems": [],
                                                        "isDefault": false,
                                                        "ratingItem": {
                                                            "ratingItemId": 60,
                                                            "ratingItemDescription": "Expiration Date: *",
                                                            "lowerLimit": null,
                                                            "upperLimit": null,
                                                            "createUser": "Migration.Seeder",
                                                            "createDate": "2020-02-05T00:05:03.7219203",
                                                            "lastUpdatedUser": null,
                                                            "lastUpdatedDate": null,
                                                            "disabled": false,
                                                            "systemNotes": null,
                                                            "userEmail": null,
                                                            "errors": [],
                                                            "isSuccessful": true
                                                        },
                                                        "hasChildren": false,
                                                        "intrinsicValue": null,
                                                        "businessName": "Expiration Date",
                                                        "createUser": "Migration.Seeder",
                                                        "createDate": "2020-02-05T00:05:25.7004791",
                                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                                        "disabled": false,
                                                        "systemNotes": null,
                                                        "userEmail": null,
                                                        "errors": [],
                                                        "isSuccessful": true
                                                    },
                                                    {
                                                        "programEnrollmentRatingItemId": 123,
                                                        "programEnrollmentRatingGroupId": 21,
                                                        "programEnrollmentId": 4,
                                                        "parentItemId": 119,
                                                        "sectionDisplaySequence": null,
                                                        "groupDisplaySequence": 4,
                                                        "displaySequence": 19,
                                                        "premium": 0,
                                                        "deductible": null,
                                                        "factor": 0,
                                                        "lowerLimit": null,
                                                        "upperLimit": null,
                                                        "lowerStringLimit": null,
                                                        "upperStringLimit": null,
                                                        "minSelection": null,
                                                        "maxSelection": null,
                                                        "lowerLimitCoverageTypeId": null,
                                                        "upperLimitCoverageTypeId": null,
                                                        "agencyFee": null,
                                                        "isFactorable": false,
                                                        "ratingItemId": 58,
                                                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                                        "ratingGroupDescription": "",
                                                        "parentRatingItemDescription": "Yes",
                                                        "overrideDescription": "Retroactive Date",
                                                        "parentRatingType": 4,
                                                        "specialInstruction": null,
                                                        "defaultSelectedState": false,
                                                        "value": null,
                                                        "numericDataType": 0,
                                                        "ratingType": 11,
                                                        "groupRatingType": 0,
                                                        "conditional": false,
                                                        "functionType": 0,
                                                        "stringFunctionType": "None",
                                                        "programEnrollmentDocumentId": null,
                                                        "programEnrollmentDocument": null,
                                                        "stringRatingType": "FreeText",
                                                        "minPremium": null,
                                                        "maxPremium": null,
                                                        "uiIsRequired": null,
                                                        "uiIsReadonly": null,
                                                        "uiControlId": 6,
                                                        "uiControl": 6,
                                                        "uiControlAggregateFunctionId": null,
                                                        "uiControlAggregateFunction": 0,
                                                        "stringUiControlAggregateFunction": "None",
                                                        "validationTargetValue": null,
                                                        "validationTargetItemId": null,
                                                        "sectionId": null,
                                                        "sectionName": null,
                                                        "sectionIndicator": false,
                                                        "uniqueIdentifier": "4-21-123",
                                                        "visible": true,
                                                        "adminVisible": true,
                                                        "excludeFromReport": false,
                                                        "semanticItemId": null,
                                                        "semanticParentItemId": null,
                                                        "hint": null,
                                                        "placeHolder": null,
                                                        "mask": null,
                                                        "className": null,
                                                        "display": "Retroactive Date (date your policy was effective): *",
                                                        "relatedItems": [],
                                                        "isDefault": false,
                                                        "ratingItem": {
                                                            "ratingItemId": 58,
                                                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                                            "lowerLimit": null,
                                                            "upperLimit": null,
                                                            "createUser": "Migration.Seeder",
                                                            "createDate": "2020-02-05T00:05:03.7219203",
                                                            "lastUpdatedUser": null,
                                                            "lastUpdatedDate": null,
                                                            "disabled": false,
                                                            "systemNotes": null,
                                                            "userEmail": null,
                                                            "errors": [],
                                                            "isSuccessful": true
                                                        },
                                                        "hasChildren": false,
                                                        "intrinsicValue": null,
                                                        "businessName": "Retroactive Date",
                                                        "createUser": "Migration.Seeder",
                                                        "createDate": "2020-02-05T00:05:25.7004791",
                                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                                        "disabled": false,
                                                        "systemNotes": null,
                                                        "userEmail": null,
                                                        "errors": [],
                                                        "isSuccessful": true
                                                    },
                                                    {
                                                        "programEnrollmentRatingItemId": 124,
                                                        "programEnrollmentRatingGroupId": 21,
                                                        "programEnrollmentId": 4,
                                                        "parentItemId": 119,
                                                        "sectionDisplaySequence": null,
                                                        "groupDisplaySequence": 4,
                                                        "displaySequence": 20,
                                                        "premium": 0,
                                                        "deductible": null,
                                                        "factor": 0,
                                                        "lowerLimit": null,
                                                        "upperLimit": null,
                                                        "lowerStringLimit": null,
                                                        "upperStringLimit": null,
                                                        "minSelection": null,
                                                        "maxSelection": null,
                                                        "lowerLimitCoverageTypeId": null,
                                                        "upperLimitCoverageTypeId": null,
                                                        "agencyFee": null,
                                                        "isFactorable": false,
                                                        "ratingItemId": 62,
                                                        "ratingItemDescription": "Carrier: *",
                                                        "ratingGroupDescription": "",
                                                        "parentRatingItemDescription": "Yes",
                                                        "overrideDescription": "Carrier",
                                                        "parentRatingType": 4,
                                                        "specialInstruction": null,
                                                        "defaultSelectedState": false,
                                                        "value": null,
                                                        "numericDataType": 0,
                                                        "ratingType": 11,
                                                        "groupRatingType": 0,
                                                        "conditional": false,
                                                        "functionType": 0,
                                                        "stringFunctionType": "None",
                                                        "programEnrollmentDocumentId": null,
                                                        "programEnrollmentDocument": null,
                                                        "stringRatingType": "FreeText",
                                                        "minPremium": null,
                                                        "maxPremium": null,
                                                        "uiIsRequired": null,
                                                        "uiIsReadonly": null,
                                                        "uiControlId": 2,
                                                        "uiControl": 2,
                                                        "uiControlAggregateFunctionId": null,
                                                        "uiControlAggregateFunction": 0,
                                                        "stringUiControlAggregateFunction": "None",
                                                        "validationTargetValue": null,
                                                        "validationTargetItemId": null,
                                                        "sectionId": null,
                                                        "sectionName": null,
                                                        "sectionIndicator": false,
                                                        "uniqueIdentifier": "4-21-124",
                                                        "visible": true,
                                                        "adminVisible": true,
                                                        "excludeFromReport": false,
                                                        "semanticItemId": null,
                                                        "semanticParentItemId": null,
                                                        "hint": null,
                                                        "placeHolder": null,
                                                        "mask": null,
                                                        "className": null,
                                                        "display": "Carrier: *",
                                                        "relatedItems": [],
                                                        "isDefault": false,
                                                        "ratingItem": {
                                                            "ratingItemId": 62,
                                                            "ratingItemDescription": "Carrier: *",
                                                            "lowerLimit": null,
                                                            "upperLimit": null,
                                                            "createUser": "Migration.Seeder",
                                                            "createDate": "2020-02-05T00:05:03.7219203",
                                                            "lastUpdatedUser": null,
                                                            "lastUpdatedDate": null,
                                                            "disabled": false,
                                                            "systemNotes": null,
                                                            "userEmail": null,
                                                            "errors": [],
                                                            "isSuccessful": true
                                                        },
                                                        "hasChildren": false,
                                                        "intrinsicValue": null,
                                                        "businessName": "Carrier",
                                                        "createUser": "Migration.Seeder",
                                                        "createDate": "2020-02-05T00:05:25.7004791",
                                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                                        "disabled": false,
                                                        "systemNotes": null,
                                                        "userEmail": null,
                                                        "errors": [],
                                                        "isSuccessful": true
                                                    }
                                                ],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 9998,
                                                    "ratingItemDescription": "Yes",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": true,
                                                "intrinsicValue": null,
                                                "businessName": "Yes",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            },
                                            {
                                                "programEnrollmentRatingItemId": 120,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 118,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 16,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 9999,
                                                "ratingItemDescription": "No",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                                "overrideDescription": "No",
                                                "parentRatingType": 3,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 4,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "Selection",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 13,
                                                "uiControl": 13,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-120",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "No",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 9999,
                                                    "ratingItemDescription": "No",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "No",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            }
                                        ],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 61,
                                            "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": true,
                                        "intrinsicValue": null,
                                        "businessName": "Are you currently Insured under another E&O program?",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.908112",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 57,
                            "ratingItemDescription": "Are you currently Insured under the ATA E&O program? *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Are you currently Insured under the ATA E&O program?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 113,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 112,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under the ATA E&O program?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-113",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 115,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 113,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 11,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 58,
                                "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Retroactive Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-115",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Retroactive Date (date your policy was effective): *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 58,
                                    "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Retroactive Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 116,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 113,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 12,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 59,
                                "ratingItemDescription": "Policy #: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Policy #",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-116",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Policy #: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 59,
                                    "ratingItemDescription": "Policy #: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Policy #",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 117,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 113,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 13,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 60,
                                "ratingItemDescription": "Expiration Date: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Expiration Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-117",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Expiration Date: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 60,
                                    "ratingItemDescription": "Expiration Date: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Expiration Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 113,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 112,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under the ATA E&O program?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-113",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 115,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 113,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 11,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 58,
                                "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Retroactive Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-115",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Retroactive Date (date your policy was effective): *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 58,
                                    "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Retroactive Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 116,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 113,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 12,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 59,
                                "ratingItemDescription": "Policy #: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Policy #",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-116",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Policy #: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 59,
                                    "ratingItemDescription": "Policy #: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Policy #",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 117,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 113,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 13,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 60,
                                "ratingItemDescription": "Expiration Date: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Expiration Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-117",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Expiration Date: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 60,
                                    "ratingItemDescription": "Expiration Date: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Expiration Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 114,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 112,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under the ATA E&O program?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-114",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 118,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 114,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 14,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 61,
                                "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "No",
                                "overrideDescription": "Are you currently Insured under another E&O program?",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 3,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Boolean",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 12,
                                "uiControl": 12,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-118",
                                "visible": true,
                                "adminVisible": false,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Are you currently Insured under another E&O program? *",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 119,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 118,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 15,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9998,
                                        "ratingItemDescription": "Yes",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                        "overrideDescription": "Yes",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-119",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Yes",
                                        "relatedItems": [
                                            {
                                                "programEnrollmentRatingItemId": 121,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 119,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 17,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 59,
                                                "ratingItemDescription": "Policy #: *",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Policy #",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 2,
                                                "uiControl": 2,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-121",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Policy #: *",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 59,
                                                    "ratingItemDescription": "Policy #: *",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Policy #",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            },
                                            {
                                                "programEnrollmentRatingItemId": 122,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 119,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 18,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 60,
                                                "ratingItemDescription": "Expiration Date: *",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Expiration Date",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 6,
                                                "uiControl": 6,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-122",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Expiration Date: *",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 60,
                                                    "ratingItemDescription": "Expiration Date: *",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Expiration Date",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            },
                                            {
                                                "programEnrollmentRatingItemId": 123,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 119,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 19,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 58,
                                                "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Retroactive Date",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 6,
                                                "uiControl": 6,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-123",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Retroactive Date (date your policy was effective): *",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 58,
                                                    "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Retroactive Date",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            },
                                            {
                                                "programEnrollmentRatingItemId": 124,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 119,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 20,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 62,
                                                "ratingItemDescription": "Carrier: *",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Carrier",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 2,
                                                "uiControl": 2,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-124",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Carrier: *",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 62,
                                                    "ratingItemDescription": "Carrier: *",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Carrier",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            }
                                        ],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9998,
                                            "ratingItemDescription": "Yes",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": true,
                                        "intrinsicValue": null,
                                        "businessName": "Yes",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 120,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 118,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 16,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9999,
                                        "ratingItemDescription": "No",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                        "overrideDescription": "No",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-120",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "No",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9999,
                                            "ratingItemDescription": "No",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "No",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 61,
                                    "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Are you currently Insured under another E&O program?",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.908112",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 114,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 112,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under the ATA E&O program?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-114",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 118,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 114,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 14,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 61,
                                "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "No",
                                "overrideDescription": "Are you currently Insured under another E&O program?",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 3,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Boolean",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 12,
                                "uiControl": 12,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-118",
                                "visible": true,
                                "adminVisible": false,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Are you currently Insured under another E&O program? *",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 119,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 118,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 15,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9998,
                                        "ratingItemDescription": "Yes",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                        "overrideDescription": "Yes",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-119",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Yes",
                                        "relatedItems": [
                                            {
                                                "programEnrollmentRatingItemId": 121,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 119,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 17,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 59,
                                                "ratingItemDescription": "Policy #: *",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Policy #",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 2,
                                                "uiControl": 2,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-121",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Policy #: *",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 59,
                                                    "ratingItemDescription": "Policy #: *",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Policy #",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            },
                                            {
                                                "programEnrollmentRatingItemId": 122,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 119,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 18,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 60,
                                                "ratingItemDescription": "Expiration Date: *",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Expiration Date",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 6,
                                                "uiControl": 6,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-122",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Expiration Date: *",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 60,
                                                    "ratingItemDescription": "Expiration Date: *",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Expiration Date",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            },
                                            {
                                                "programEnrollmentRatingItemId": 123,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 119,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 19,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 58,
                                                "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Retroactive Date",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 6,
                                                "uiControl": 6,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-123",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Retroactive Date (date your policy was effective): *",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 58,
                                                    "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Retroactive Date",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            },
                                            {
                                                "programEnrollmentRatingItemId": 124,
                                                "programEnrollmentRatingGroupId": 21,
                                                "programEnrollmentId": 4,
                                                "parentItemId": 119,
                                                "sectionDisplaySequence": null,
                                                "groupDisplaySequence": 4,
                                                "displaySequence": 20,
                                                "premium": 0,
                                                "deductible": null,
                                                "factor": 0,
                                                "lowerLimit": null,
                                                "upperLimit": null,
                                                "lowerStringLimit": null,
                                                "upperStringLimit": null,
                                                "minSelection": null,
                                                "maxSelection": null,
                                                "lowerLimitCoverageTypeId": null,
                                                "upperLimitCoverageTypeId": null,
                                                "agencyFee": null,
                                                "isFactorable": false,
                                                "ratingItemId": 62,
                                                "ratingItemDescription": "Carrier: *",
                                                "ratingGroupDescription": "",
                                                "parentRatingItemDescription": "Yes",
                                                "overrideDescription": "Carrier",
                                                "parentRatingType": 4,
                                                "specialInstruction": null,
                                                "defaultSelectedState": false,
                                                "value": null,
                                                "numericDataType": 0,
                                                "ratingType": 11,
                                                "groupRatingType": 0,
                                                "conditional": false,
                                                "functionType": 0,
                                                "stringFunctionType": "None",
                                                "programEnrollmentDocumentId": null,
                                                "programEnrollmentDocument": null,
                                                "stringRatingType": "FreeText",
                                                "minPremium": null,
                                                "maxPremium": null,
                                                "uiIsRequired": null,
                                                "uiIsReadonly": null,
                                                "uiControlId": 2,
                                                "uiControl": 2,
                                                "uiControlAggregateFunctionId": null,
                                                "uiControlAggregateFunction": 0,
                                                "stringUiControlAggregateFunction": "None",
                                                "validationTargetValue": null,
                                                "validationTargetItemId": null,
                                                "sectionId": null,
                                                "sectionName": null,
                                                "sectionIndicator": false,
                                                "uniqueIdentifier": "4-21-124",
                                                "visible": true,
                                                "adminVisible": true,
                                                "excludeFromReport": false,
                                                "semanticItemId": null,
                                                "semanticParentItemId": null,
                                                "hint": null,
                                                "placeHolder": null,
                                                "mask": null,
                                                "className": null,
                                                "display": "Carrier: *",
                                                "relatedItems": [],
                                                "isDefault": false,
                                                "ratingItem": {
                                                    "ratingItemId": 62,
                                                    "ratingItemDescription": "Carrier: *",
                                                    "lowerLimit": null,
                                                    "upperLimit": null,
                                                    "createUser": "Migration.Seeder",
                                                    "createDate": "2020-02-05T00:05:03.7219203",
                                                    "lastUpdatedUser": null,
                                                    "lastUpdatedDate": null,
                                                    "disabled": false,
                                                    "systemNotes": null,
                                                    "userEmail": null,
                                                    "errors": [],
                                                    "isSuccessful": true
                                                },
                                                "hasChildren": false,
                                                "intrinsicValue": null,
                                                "businessName": "Carrier",
                                                "createUser": "Migration.Seeder",
                                                "createDate": "2020-02-05T00:05:25.7004791",
                                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                                "disabled": false,
                                                "systemNotes": null,
                                                "userEmail": null,
                                                "errors": [],
                                                "isSuccessful": true
                                            }
                                        ],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9998,
                                            "ratingItemDescription": "Yes",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": true,
                                        "intrinsicValue": null,
                                        "businessName": "Yes",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 120,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 118,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 16,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 9999,
                                        "ratingItemDescription": "No",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                        "overrideDescription": "No",
                                        "parentRatingType": 3,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 4,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "Selection",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 13,
                                        "uiControl": 13,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-120",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "No",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 9999,
                                            "ratingItemDescription": "No",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "No",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 61,
                                    "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Are you currently Insured under another E&O program?",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.908112",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 115,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 113,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 11,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 58,
                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Retroactive Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-115",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Retroactive Date (date your policy was effective): *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 58,
                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Retroactive Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 115,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 113,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 11,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 58,
                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Retroactive Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-115",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Retroactive Date (date your policy was effective): *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 58,
                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Retroactive Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 115,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 113,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 11,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 58,
                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Retroactive Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-115",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Retroactive Date (date your policy was effective): *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 58,
                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Retroactive Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 116,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 113,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 12,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 59,
                        "ratingItemDescription": "Policy #: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Policy #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-116",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Policy #: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 59,
                            "ratingItemDescription": "Policy #: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Policy #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 116,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 113,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 12,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 59,
                        "ratingItemDescription": "Policy #: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Policy #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-116",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Policy #: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 59,
                            "ratingItemDescription": "Policy #: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Policy #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 116,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 113,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 12,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 59,
                        "ratingItemDescription": "Policy #: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Policy #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-116",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Policy #: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 59,
                            "ratingItemDescription": "Policy #: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Policy #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 117,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 113,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 13,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 60,
                        "ratingItemDescription": "Expiration Date: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Expiration Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-117",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Expiration Date: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 60,
                            "ratingItemDescription": "Expiration Date: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Expiration Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 117,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 113,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 13,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 60,
                        "ratingItemDescription": "Expiration Date: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Expiration Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-117",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Expiration Date: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 60,
                            "ratingItemDescription": "Expiration Date: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Expiration Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 117,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 113,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 13,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 60,
                        "ratingItemDescription": "Expiration Date: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Expiration Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-117",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Expiration Date: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 60,
                            "ratingItemDescription": "Expiration Date: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Expiration Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 118,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 114,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 14,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 61,
                        "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "No",
                        "overrideDescription": "Are you currently Insured under another E&O program?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-118",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Are you currently Insured under another E&O program? *",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 119,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 118,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 15,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-119",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 121,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 17,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 59,
                                        "ratingItemDescription": "Policy #: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Policy #",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-121",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Policy #: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 59,
                                            "ratingItemDescription": "Policy #: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Policy #",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 122,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 18,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 60,
                                        "ratingItemDescription": "Expiration Date: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Expiration Date",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 6,
                                        "uiControl": 6,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-122",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Expiration Date: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 60,
                                            "ratingItemDescription": "Expiration Date: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Expiration Date",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 123,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 19,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 58,
                                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Retroactive Date",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 6,
                                        "uiControl": 6,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-123",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Retroactive Date (date your policy was effective): *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 58,
                                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Retroactive Date",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 124,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 20,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 62,
                                        "ratingItemDescription": "Carrier: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Carrier",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-124",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Carrier: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 62,
                                            "ratingItemDescription": "Carrier: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Carrier",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 120,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 118,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 16,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-120",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 61,
                            "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Are you currently Insured under another E&O program?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.908112",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 118,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 114,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 14,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 61,
                        "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "No",
                        "overrideDescription": "Are you currently Insured under another E&O program?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-118",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Are you currently Insured under another E&O program? *",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 119,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 118,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 15,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-119",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 121,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 17,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 59,
                                        "ratingItemDescription": "Policy #: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Policy #",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-121",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Policy #: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 59,
                                            "ratingItemDescription": "Policy #: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Policy #",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 122,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 18,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 60,
                                        "ratingItemDescription": "Expiration Date: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Expiration Date",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 6,
                                        "uiControl": 6,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-122",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Expiration Date: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 60,
                                            "ratingItemDescription": "Expiration Date: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Expiration Date",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 123,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 19,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 58,
                                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Retroactive Date",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 6,
                                        "uiControl": 6,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-123",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Retroactive Date (date your policy was effective): *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 58,
                                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Retroactive Date",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 124,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 20,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 62,
                                        "ratingItemDescription": "Carrier: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Carrier",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-124",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Carrier: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 62,
                                            "ratingItemDescription": "Carrier: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Carrier",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 120,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 118,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 16,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-120",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 61,
                            "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Are you currently Insured under another E&O program?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.908112",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 118,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 114,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 14,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 61,
                        "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "No",
                        "overrideDescription": "Are you currently Insured under another E&O program?",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 3,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Boolean",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 12,
                        "uiControl": 12,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-118",
                        "visible": true,
                        "adminVisible": false,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Are you currently Insured under another E&O program? *",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 119,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 118,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 15,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9998,
                                "ratingItemDescription": "Yes",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                "overrideDescription": "Yes",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-119",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Yes",
                                "relatedItems": [
                                    {
                                        "programEnrollmentRatingItemId": 121,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 17,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 59,
                                        "ratingItemDescription": "Policy #: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Policy #",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-121",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Policy #: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 59,
                                            "ratingItemDescription": "Policy #: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Policy #",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 122,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 18,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 60,
                                        "ratingItemDescription": "Expiration Date: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Expiration Date",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 6,
                                        "uiControl": 6,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-122",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Expiration Date: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 60,
                                            "ratingItemDescription": "Expiration Date: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Expiration Date",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 123,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 19,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 58,
                                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Retroactive Date",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 6,
                                        "uiControl": 6,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-123",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Retroactive Date (date your policy was effective): *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 58,
                                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Retroactive Date",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    {
                                        "programEnrollmentRatingItemId": 124,
                                        "programEnrollmentRatingGroupId": 21,
                                        "programEnrollmentId": 4,
                                        "parentItemId": 119,
                                        "sectionDisplaySequence": null,
                                        "groupDisplaySequence": 4,
                                        "displaySequence": 20,
                                        "premium": 0,
                                        "deductible": null,
                                        "factor": 0,
                                        "lowerLimit": null,
                                        "upperLimit": null,
                                        "lowerStringLimit": null,
                                        "upperStringLimit": null,
                                        "minSelection": null,
                                        "maxSelection": null,
                                        "lowerLimitCoverageTypeId": null,
                                        "upperLimitCoverageTypeId": null,
                                        "agencyFee": null,
                                        "isFactorable": false,
                                        "ratingItemId": 62,
                                        "ratingItemDescription": "Carrier: *",
                                        "ratingGroupDescription": "",
                                        "parentRatingItemDescription": "Yes",
                                        "overrideDescription": "Carrier",
                                        "parentRatingType": 4,
                                        "specialInstruction": null,
                                        "defaultSelectedState": false,
                                        "value": null,
                                        "numericDataType": 0,
                                        "ratingType": 11,
                                        "groupRatingType": 0,
                                        "conditional": false,
                                        "functionType": 0,
                                        "stringFunctionType": "None",
                                        "programEnrollmentDocumentId": null,
                                        "programEnrollmentDocument": null,
                                        "stringRatingType": "FreeText",
                                        "minPremium": null,
                                        "maxPremium": null,
                                        "uiIsRequired": null,
                                        "uiIsReadonly": null,
                                        "uiControlId": 2,
                                        "uiControl": 2,
                                        "uiControlAggregateFunctionId": null,
                                        "uiControlAggregateFunction": 0,
                                        "stringUiControlAggregateFunction": "None",
                                        "validationTargetValue": null,
                                        "validationTargetItemId": null,
                                        "sectionId": null,
                                        "sectionName": null,
                                        "sectionIndicator": false,
                                        "uniqueIdentifier": "4-21-124",
                                        "visible": true,
                                        "adminVisible": true,
                                        "excludeFromReport": false,
                                        "semanticItemId": null,
                                        "semanticParentItemId": null,
                                        "hint": null,
                                        "placeHolder": null,
                                        "mask": null,
                                        "className": null,
                                        "display": "Carrier: *",
                                        "relatedItems": [],
                                        "isDefault": false,
                                        "ratingItem": {
                                            "ratingItemId": 62,
                                            "ratingItemDescription": "Carrier: *",
                                            "lowerLimit": null,
                                            "upperLimit": null,
                                            "createUser": "Migration.Seeder",
                                            "createDate": "2020-02-05T00:05:03.7219203",
                                            "lastUpdatedUser": null,
                                            "lastUpdatedDate": null,
                                            "disabled": false,
                                            "systemNotes": null,
                                            "userEmail": null,
                                            "errors": [],
                                            "isSuccessful": true
                                        },
                                        "hasChildren": false,
                                        "intrinsicValue": null,
                                        "businessName": "Carrier",
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:25.7004791",
                                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    }
                                ],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9998,
                                    "ratingItemDescription": "Yes",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": true,
                                "intrinsicValue": null,
                                "businessName": "Yes",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 120,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 118,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 16,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 9999,
                                "ratingItemDescription": "No",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                                "overrideDescription": "No",
                                "parentRatingType": 3,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 4,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Selection",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 13,
                                "uiControl": 13,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-120",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "No",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 9999,
                                    "ratingItemDescription": "No",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "No",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 61,
                            "ratingItemDescription": "Are you currently Insured under another E&O program? *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Are you currently Insured under another E&O program?",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.908112",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 119,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 118,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 15,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-119",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 121,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 17,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 59,
                                "ratingItemDescription": "Policy #: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Policy #",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-121",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Policy #: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 59,
                                    "ratingItemDescription": "Policy #: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Policy #",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 122,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 18,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 60,
                                "ratingItemDescription": "Expiration Date: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Expiration Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-122",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Expiration Date: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 60,
                                    "ratingItemDescription": "Expiration Date: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Expiration Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 123,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 19,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 58,
                                "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Retroactive Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-123",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Retroactive Date (date your policy was effective): *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 58,
                                    "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Retroactive Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 124,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 20,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 62,
                                "ratingItemDescription": "Carrier: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Carrier",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-124",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Carrier: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 62,
                                    "ratingItemDescription": "Carrier: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Carrier",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 119,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 118,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 15,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-119",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 121,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 17,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 59,
                                "ratingItemDescription": "Policy #: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Policy #",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-121",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Policy #: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 59,
                                    "ratingItemDescription": "Policy #: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Policy #",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 122,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 18,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 60,
                                "ratingItemDescription": "Expiration Date: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Expiration Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-122",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Expiration Date: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 60,
                                    "ratingItemDescription": "Expiration Date: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Expiration Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 123,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 19,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 58,
                                "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Retroactive Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-123",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Retroactive Date (date your policy was effective): *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 58,
                                    "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Retroactive Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 124,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 20,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 62,
                                "ratingItemDescription": "Carrier: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Carrier",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-124",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Carrier: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 62,
                                    "ratingItemDescription": "Carrier: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Carrier",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 119,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 118,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 15,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-119",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 121,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 17,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 59,
                                "ratingItemDescription": "Policy #: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Policy #",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-121",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Policy #: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 59,
                                    "ratingItemDescription": "Policy #: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Policy #",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 122,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 18,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 60,
                                "ratingItemDescription": "Expiration Date: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Expiration Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-122",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Expiration Date: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 60,
                                    "ratingItemDescription": "Expiration Date: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Expiration Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 123,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 19,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 58,
                                "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Retroactive Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-123",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Retroactive Date (date your policy was effective): *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 58,
                                    "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Retroactive Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 124,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 20,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 62,
                                "ratingItemDescription": "Carrier: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Carrier",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-124",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Carrier: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 62,
                                    "ratingItemDescription": "Carrier: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Carrier",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 119,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 118,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 15,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9998,
                        "ratingItemDescription": "Yes",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                        "overrideDescription": "Yes",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-119",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Yes",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 121,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 17,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 59,
                                "ratingItemDescription": "Policy #: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Policy #",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-121",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Policy #: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 59,
                                    "ratingItemDescription": "Policy #: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Policy #",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 122,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 18,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 60,
                                "ratingItemDescription": "Expiration Date: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Expiration Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-122",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Expiration Date: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 60,
                                    "ratingItemDescription": "Expiration Date: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Expiration Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 123,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 19,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 58,
                                "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Retroactive Date",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 6,
                                "uiControl": 6,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-123",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Retroactive Date (date your policy was effective): *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 58,
                                    "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Retroactive Date",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 124,
                                "programEnrollmentRatingGroupId": 21,
                                "programEnrollmentId": 4,
                                "parentItemId": 119,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 4,
                                "displaySequence": 20,
                                "premium": 0,
                                "deductible": null,
                                "factor": 0,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 62,
                                "ratingItemDescription": "Carrier: *",
                                "ratingGroupDescription": "",
                                "parentRatingItemDescription": "Yes",
                                "overrideDescription": "Carrier",
                                "parentRatingType": 4,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 11,
                                "groupRatingType": 0,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "FreeText",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 2,
                                "uiControl": 2,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-21-124",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": false,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "Carrier: *",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 62,
                                    "ratingItemDescription": "Carrier: *",
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": null,
                                "businessName": "Carrier",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                                "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9998,
                            "ratingItemDescription": "Yes",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Yes",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9376271",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 120,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 118,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 16,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-120",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 120,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 118,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 16,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-120",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 120,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 118,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 16,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-120",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 120,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 118,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 16,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9999,
                        "ratingItemDescription": "No",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Are you currently Insured under another E&O program?",
                        "overrideDescription": "No",
                        "parentRatingType": 3,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 4,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Selection",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 13,
                        "uiControl": 13,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-120",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "No",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9999,
                            "ratingItemDescription": "No",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "No",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9500028",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 121,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 17,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 59,
                        "ratingItemDescription": "Policy #: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Policy #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-121",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Policy #: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 59,
                            "ratingItemDescription": "Policy #: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Policy #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 121,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 17,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 59,
                        "ratingItemDescription": "Policy #: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Policy #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-121",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Policy #: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 59,
                            "ratingItemDescription": "Policy #: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Policy #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 121,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 17,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 59,
                        "ratingItemDescription": "Policy #: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Policy #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-121",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Policy #: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 59,
                            "ratingItemDescription": "Policy #: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Policy #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 121,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 17,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 59,
                        "ratingItemDescription": "Policy #: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Policy #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-121",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Policy #: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 59,
                            "ratingItemDescription": "Policy #: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Policy #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 121,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 17,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 59,
                        "ratingItemDescription": "Policy #: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Policy #",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-121",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Policy #: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 59,
                            "ratingItemDescription": "Policy #: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Policy #",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 122,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 18,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 60,
                        "ratingItemDescription": "Expiration Date: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Expiration Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-122",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Expiration Date: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 60,
                            "ratingItemDescription": "Expiration Date: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Expiration Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 122,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 18,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 60,
                        "ratingItemDescription": "Expiration Date: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Expiration Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-122",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Expiration Date: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 60,
                            "ratingItemDescription": "Expiration Date: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Expiration Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 122,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 18,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 60,
                        "ratingItemDescription": "Expiration Date: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Expiration Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-122",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Expiration Date: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 60,
                            "ratingItemDescription": "Expiration Date: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Expiration Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 122,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 18,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 60,
                        "ratingItemDescription": "Expiration Date: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Expiration Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-122",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Expiration Date: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 60,
                            "ratingItemDescription": "Expiration Date: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Expiration Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 122,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 18,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 60,
                        "ratingItemDescription": "Expiration Date: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Expiration Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-122",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Expiration Date: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 60,
                            "ratingItemDescription": "Expiration Date: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Expiration Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9683282",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 123,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 19,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 58,
                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Retroactive Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-123",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Retroactive Date (date your policy was effective): *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 58,
                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Retroactive Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 123,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 19,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 58,
                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Retroactive Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-123",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Retroactive Date (date your policy was effective): *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 58,
                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Retroactive Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 123,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 19,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 58,
                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Retroactive Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-123",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Retroactive Date (date your policy was effective): *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 58,
                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Retroactive Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 123,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 19,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 58,
                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Retroactive Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-123",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Retroactive Date (date your policy was effective): *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 58,
                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Retroactive Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 123,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 19,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 58,
                        "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Retroactive Date",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 6,
                        "uiControl": 6,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-123",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Retroactive Date (date your policy was effective): *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 58,
                            "ratingItemDescription": "Retroactive Date (date your policy was effective): *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Retroactive Date",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 124,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 20,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 62,
                        "ratingItemDescription": "Carrier: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Carrier",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-124",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Carrier: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 62,
                            "ratingItemDescription": "Carrier: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Carrier",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 124,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 20,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 62,
                        "ratingItemDescription": "Carrier: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Carrier",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-124",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Carrier: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 62,
                            "ratingItemDescription": "Carrier: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Carrier",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 124,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 20,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 62,
                        "ratingItemDescription": "Carrier: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Carrier",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-124",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Carrier: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 62,
                            "ratingItemDescription": "Carrier: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Carrier",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 124,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 20,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 62,
                        "ratingItemDescription": "Carrier: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Carrier",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-124",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Carrier: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 62,
                            "ratingItemDescription": "Carrier: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Carrier",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 124,
                        "programEnrollmentRatingGroupId": 21,
                        "programEnrollmentId": 4,
                        "parentItemId": 119,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 4,
                        "displaySequence": 20,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 62,
                        "ratingItemDescription": "Carrier: *",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "Yes",
                        "overrideDescription": "Carrier",
                        "parentRatingType": 4,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 11,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeText",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 2,
                        "uiControl": 2,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-21-124",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "Carrier: *",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 62,
                            "ratingItemDescription": "Carrier: *",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": null,
                        "businessName": "Carrier",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItems",
                        "lastUpdatedDate": "2020-05-01T01:09:11.9812529",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 23,
                "programEnrollmentId": 4,
                "ratingType": 31,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 3,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Deductibles",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "Factor",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 193,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 0,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": 1,
                        "maxSelection": 1,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 9995,
                        "ratingItemDescription": "Top level item of a selection (Parent)",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Deductibles",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 0,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "None",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 5,
                        "uiControl": 5,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-193",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": "Available deductibles based on limit...",
                        "mask": null,
                        "className": null,
                        "display": "Deductibles",
                        "relatedItems": [
                            {
                                "programEnrollmentRatingItemId": 125,
                                "programEnrollmentRatingGroupId": 23,
                                "programEnrollmentId": 4,
                                "parentItemId": 193,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 3,
                                "displaySequence": 1,
                                "premium": 0,
                                "deductible": 250,
                                "factor": 1.05,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 63,
                                "ratingItemDescription": "$250",
                                "ratingGroupDescription": "Deductibles",
                                "parentRatingItemDescription": "Deductibles",
                                "overrideDescription": "$250",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-23-125",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$250",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 63,
                                    "ratingItemDescription": "$250",
                                    "lowerLimit": null,
                                    "upperLimit": 250,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "1.05000000000000000000",
                                "businessName": "$250",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 126,
                                "programEnrollmentRatingGroupId": 23,
                                "programEnrollmentId": 4,
                                "parentItemId": 193,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 3,
                                "displaySequence": 2,
                                "premium": 0,
                                "deductible": 500,
                                "factor": 1,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 64,
                                "ratingItemDescription": "$500",
                                "ratingGroupDescription": "Deductibles",
                                "parentRatingItemDescription": "Deductibles",
                                "overrideDescription": "$500",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-23-126",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$500",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 64,
                                    "ratingItemDescription": "$500",
                                    "lowerLimit": null,
                                    "upperLimit": 500,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "1.00000000000000000000",
                                "businessName": "$500",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 127,
                                "programEnrollmentRatingGroupId": 23,
                                "programEnrollmentId": 4,
                                "parentItemId": 193,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 3,
                                "displaySequence": 3,
                                "premium": 0,
                                "deductible": 1000,
                                "factor": 0.925,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 65,
                                "ratingItemDescription": "$1,000",
                                "ratingGroupDescription": "Deductibles",
                                "parentRatingItemDescription": "Deductibles",
                                "overrideDescription": "$1,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-23-127",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$1,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 65,
                                    "ratingItemDescription": "$1,000",
                                    "lowerLimit": null,
                                    "upperLimit": 1000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "0.92500000000000000000",
                                "businessName": "$1,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 128,
                                "programEnrollmentRatingGroupId": 23,
                                "programEnrollmentId": 4,
                                "parentItemId": 193,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 3,
                                "displaySequence": 4,
                                "premium": 0,
                                "deductible": 2500,
                                "factor": 0.875,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 66,
                                "ratingItemDescription": "$2,500",
                                "ratingGroupDescription": "Deductibles",
                                "parentRatingItemDescription": "Deductibles",
                                "overrideDescription": "$2,500",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-23-128",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$2,500",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 66,
                                    "ratingItemDescription": "$2,500",
                                    "lowerLimit": null,
                                    "upperLimit": 2500,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "0.87500000000000000000",
                                "businessName": "$2,500",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 129,
                                "programEnrollmentRatingGroupId": 23,
                                "programEnrollmentId": 4,
                                "parentItemId": 193,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 3,
                                "displaySequence": 5,
                                "premium": 0,
                                "deductible": 5000,
                                "factor": 0.825,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 67,
                                "ratingItemDescription": "$5,000",
                                "ratingGroupDescription": "Deductibles",
                                "parentRatingItemDescription": "Deductibles",
                                "overrideDescription": "$5,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-23-129",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$5,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 67,
                                    "ratingItemDescription": "$5,000",
                                    "lowerLimit": null,
                                    "upperLimit": 5000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "0.82500000000000000000",
                                "businessName": "$5,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            {
                                "programEnrollmentRatingItemId": 130,
                                "programEnrollmentRatingGroupId": 23,
                                "programEnrollmentId": 4,
                                "parentItemId": 193,
                                "sectionDisplaySequence": null,
                                "groupDisplaySequence": 3,
                                "displaySequence": 6,
                                "premium": 0,
                                "deductible": 10000,
                                "factor": 0.775,
                                "lowerLimit": null,
                                "upperLimit": null,
                                "lowerStringLimit": null,
                                "upperStringLimit": null,
                                "minSelection": null,
                                "maxSelection": null,
                                "lowerLimitCoverageTypeId": null,
                                "upperLimitCoverageTypeId": null,
                                "agencyFee": null,
                                "isFactorable": false,
                                "ratingItemId": 68,
                                "ratingItemDescription": "$10,000",
                                "ratingGroupDescription": "Deductibles",
                                "parentRatingItemDescription": "Deductibles",
                                "overrideDescription": "$10,000",
                                "parentRatingType": 0,
                                "specialInstruction": null,
                                "defaultSelectedState": false,
                                "value": null,
                                "numericDataType": 0,
                                "ratingType": 31,
                                "groupRatingType": 31,
                                "conditional": false,
                                "functionType": 0,
                                "stringFunctionType": "None",
                                "programEnrollmentDocumentId": null,
                                "programEnrollmentDocument": null,
                                "stringRatingType": "Factor",
                                "minPremium": null,
                                "maxPremium": null,
                                "uiIsRequired": null,
                                "uiIsReadonly": null,
                                "uiControlId": 8,
                                "uiControl": 8,
                                "uiControlAggregateFunctionId": null,
                                "uiControlAggregateFunction": 0,
                                "stringUiControlAggregateFunction": "None",
                                "validationTargetValue": null,
                                "validationTargetItemId": null,
                                "sectionId": null,
                                "sectionName": null,
                                "sectionIndicator": false,
                                "uniqueIdentifier": "4-23-130",
                                "visible": true,
                                "adminVisible": true,
                                "excludeFromReport": true,
                                "semanticItemId": null,
                                "semanticParentItemId": null,
                                "hint": null,
                                "placeHolder": null,
                                "mask": null,
                                "className": null,
                                "display": "$10,000",
                                "relatedItems": [],
                                "isDefault": false,
                                "ratingItem": {
                                    "ratingItemId": 68,
                                    "ratingItemDescription": "$10,000",
                                    "lowerLimit": null,
                                    "upperLimit": 10000,
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:03.7219203",
                                    "lastUpdatedUser": null,
                                    "lastUpdatedDate": null,
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                "hasChildren": false,
                                "intrinsicValue": "0.77500000000000000000",
                                "businessName": "$10,000",
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:25.7004791",
                                "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            }
                        ],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 9995,
                            "ratingItemDescription": "Top level item of a selection (Parent)",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": true,
                        "intrinsicValue": null,
                        "businessName": "Deductibles",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 125,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": 250,
                        "factor": 1.05,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 63,
                        "ratingItemDescription": "$250",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$250",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-125",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$250",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 63,
                            "ratingItemDescription": "$250",
                            "lowerLimit": null,
                            "upperLimit": 250,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.05000000000000000000",
                        "businessName": "$250",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 125,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": 250,
                        "factor": 1.05,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 63,
                        "ratingItemDescription": "$250",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$250",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-125",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$250",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 63,
                            "ratingItemDescription": "$250",
                            "lowerLimit": null,
                            "upperLimit": 250,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.05000000000000000000",
                        "businessName": "$250",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 126,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": 500,
                        "factor": 1,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 64,
                        "ratingItemDescription": "$500",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$500",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-126",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$500",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 64,
                            "ratingItemDescription": "$500",
                            "lowerLimit": null,
                            "upperLimit": 500,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.00000000000000000000",
                        "businessName": "$500",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 126,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 2,
                        "premium": 0,
                        "deductible": 500,
                        "factor": 1,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 64,
                        "ratingItemDescription": "$500",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$500",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-126",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$500",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 64,
                            "ratingItemDescription": "$500",
                            "lowerLimit": null,
                            "upperLimit": 500,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "1.00000000000000000000",
                        "businessName": "$500",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 127,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": 1000,
                        "factor": 0.925,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 65,
                        "ratingItemDescription": "$1,000",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$1,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-127",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$1,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 65,
                            "ratingItemDescription": "$1,000",
                            "lowerLimit": null,
                            "upperLimit": 1000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.92500000000000000000",
                        "businessName": "$1,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 127,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 3,
                        "premium": 0,
                        "deductible": 1000,
                        "factor": 0.925,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 65,
                        "ratingItemDescription": "$1,000",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$1,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-127",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$1,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 65,
                            "ratingItemDescription": "$1,000",
                            "lowerLimit": null,
                            "upperLimit": 1000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.92500000000000000000",
                        "businessName": "$1,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 128,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": 2500,
                        "factor": 0.875,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 66,
                        "ratingItemDescription": "$2,500",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$2,500",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-128",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$2,500",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 66,
                            "ratingItemDescription": "$2,500",
                            "lowerLimit": null,
                            "upperLimit": 2500,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.87500000000000000000",
                        "businessName": "$2,500",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 128,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 4,
                        "premium": 0,
                        "deductible": 2500,
                        "factor": 0.875,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 66,
                        "ratingItemDescription": "$2,500",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$2,500",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-128",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$2,500",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 66,
                            "ratingItemDescription": "$2,500",
                            "lowerLimit": null,
                            "upperLimit": 2500,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.87500000000000000000",
                        "businessName": "$2,500",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 129,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": 5000,
                        "factor": 0.825,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 67,
                        "ratingItemDescription": "$5,000",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$5,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-129",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$5,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 67,
                            "ratingItemDescription": "$5,000",
                            "lowerLimit": null,
                            "upperLimit": 5000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.82500000000000000000",
                        "businessName": "$5,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 129,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 5,
                        "premium": 0,
                        "deductible": 5000,
                        "factor": 0.825,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 67,
                        "ratingItemDescription": "$5,000",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$5,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-129",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$5,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 67,
                            "ratingItemDescription": "$5,000",
                            "lowerLimit": null,
                            "upperLimit": 5000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.82500000000000000000",
                        "businessName": "$5,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 130,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": 10000,
                        "factor": 0.775,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 68,
                        "ratingItemDescription": "$10,000",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$10,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-130",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$10,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 68,
                            "ratingItemDescription": "$10,000",
                            "lowerLimit": null,
                            "upperLimit": 10000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.77500000000000000000",
                        "businessName": "$10,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    },
                    {
                        "programEnrollmentRatingItemId": 130,
                        "programEnrollmentRatingGroupId": 23,
                        "programEnrollmentId": 4,
                        "parentItemId": 193,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 3,
                        "displaySequence": 6,
                        "premium": 0,
                        "deductible": 10000,
                        "factor": 0.775,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": false,
                        "ratingItemId": 68,
                        "ratingItemDescription": "$10,000",
                        "ratingGroupDescription": "Deductibles",
                        "parentRatingItemDescription": "Deductibles",
                        "overrideDescription": "$10,000",
                        "parentRatingType": 0,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 0,
                        "ratingType": 31,
                        "groupRatingType": 31,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "Factor",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": null,
                        "uiIsReadonly": null,
                        "uiControlId": 8,
                        "uiControl": 8,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-23-130",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": true,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": null,
                        "display": "$10,000",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 68,
                            "ratingItemDescription": "$10,000",
                            "lowerLimit": null,
                            "upperLimit": 10000,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0.77500000000000000000",
                        "businessName": "$10,000",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": true,
                "validationTarget": null,
                "excludeFromReportFlag": true,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 24,
                "programEnrollmentId": 4,
                "ratingType": 33,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 15,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Revenue Bands",
                "specialInstruction": null,
                "visible": false,
                "adminVisible": false,
                "ratingTypeDescription": "Band",
                "programEnrollmentRatingItems": [],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 25,
                "programEnrollmentId": 4,
                "ratingType": 5,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 16,
                "minSelection": 1,
                "maxSelection": 1,
                "ratingGroupDescription": "Agency Fee",
                "specialInstruction": null,
                "visible": false,
                "adminVisible": false,
                "ratingTypeDescription": "AgencyFee",
                "programEnrollmentRatingItems": [],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": true,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 26,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 17,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Additional Insured",
                "specialInstruction": null,
                "visible": false,
                "adminVisible": false,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": true,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 27,
                "programEnrollmentId": 4,
                "ratingType": 31,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 18,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Conditional Group",
                "specialInstruction": null,
                "visible": false,
                "adminVisible": false,
                "ratingTypeDescription": "Factor",
                "programEnrollmentRatingItems": [],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": true,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": true,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 28,
                "programEnrollmentId": 4,
                "ratingType": 35,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 19,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Function Group (Round To Nearest $)",
                "specialInstruction": null,
                "visible": false,
                "adminVisible": false,
                "ratingTypeDescription": "Function",
                "programEnrollmentRatingItems": [],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": true,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": true,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 29,
                "programEnrollmentId": 4,
                "ratingType": 36,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 20,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "Report",
                "specialInstruction": null,
                "visible": false,
                "adminVisible": false,
                "ratingTypeDescription": "Report",
                "programEnrollmentRatingItems": [],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": true,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": true,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupId": 39,
                "programEnrollmentId": 4,
                "ratingType": 0,
                "overrideDescription": null,
                "sectionDisplaySequence": 0,
                "displaySequence": 0,
                "minSelection": null,
                "maxSelection": null,
                "ratingGroupDescription": "",
                "specialInstruction": null,
                "visible": true,
                "adminVisible": true,
                "ratingTypeDescription": "None",
                "programEnrollmentRatingItems": [
                    {
                        "programEnrollmentRatingItemId": 194,
                        "programEnrollmentRatingGroupId": 39,
                        "programEnrollmentId": 4,
                        "parentItemId": null,
                        "sectionDisplaySequence": null,
                        "groupDisplaySequence": 0,
                        "displaySequence": 1,
                        "premium": 0,
                        "deductible": null,
                        "factor": 0,
                        "lowerLimit": null,
                        "upperLimit": null,
                        "lowerStringLimit": null,
                        "upperStringLimit": null,
                        "minSelection": null,
                        "maxSelection": null,
                        "lowerLimitCoverageTypeId": null,
                        "upperLimitCoverageTypeId": null,
                        "agencyFee": null,
                        "isFactorable": true,
                        "ratingItemId": 79,
                        "ratingItemDescription": "Number of Employees (including yourself)",
                        "ratingGroupDescription": "",
                        "parentRatingItemDescription": "",
                        "overrideDescription": "Number of Employees (including yourself)",
                        "parentRatingType": null,
                        "specialInstruction": null,
                        "defaultSelectedState": false,
                        "value": null,
                        "numericDataType": 6,
                        "ratingType": 12,
                        "groupRatingType": 0,
                        "conditional": false,
                        "functionType": 0,
                        "stringFunctionType": "None",
                        "programEnrollmentDocumentId": null,
                        "programEnrollmentDocument": null,
                        "stringRatingType": "FreeNumeric",
                        "minPremium": null,
                        "maxPremium": null,
                        "uiIsRequired": true,
                        "uiIsReadonly": false,
                        "uiControlId": 3,
                        "uiControl": 3,
                        "uiControlAggregateFunctionId": null,
                        "uiControlAggregateFunction": 0,
                        "stringUiControlAggregateFunction": "None",
                        "validationTargetValue": null,
                        "validationTargetItemId": null,
                        "sectionId": null,
                        "sectionName": null,
                        "sectionIndicator": false,
                        "uniqueIdentifier": "4-39-194",
                        "visible": true,
                        "adminVisible": true,
                        "excludeFromReport": false,
                        "semanticItemId": null,
                        "semanticParentItemId": null,
                        "hint": null,
                        "placeHolder": null,
                        "mask": null,
                        "className": "",
                        "display": "Number of Employees (including yourself)",
                        "relatedItems": [],
                        "isDefault": false,
                        "ratingItem": {
                            "ratingItemId": 79,
                            "ratingItemDescription": "Number of Employees (including yourself)",
                            "lowerLimit": null,
                            "upperLimit": null,
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:03.7219203",
                            "lastUpdatedUser": null,
                            "lastUpdatedDate": null,
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        "hasChildren": false,
                        "intrinsicValue": "0",
                        "businessName": "Number of Employees (including yourself)",
                        "createUser": "Migration.Seeder",
                        "createDate": "2020-02-05T00:05:25.7004791",
                        "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                        "lastUpdatedDate": "2020-02-05T00:07:09.02168",
                        "disabled": false,
                        "systemNotes": null,
                        "userEmail": null,
                        "errors": [],
                        "isSuccessful": true
                    }
                ],
                "programEnrollmentRatingGroupContents": [],
                "hasDeductible": false,
                "validationTarget": null,
                "excludeFromReportFlag": false,
                "sectionId": null,
                "sectionName": null,
                "sectionIndicator": false,
                "conditional": false,
                "className": null,
                "display": null,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:24.9030888",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            }
        ],
        "programEnrollmentRatingItemAssociationRules": [
            {
                "description": "Limit of $1M cannot be selected with $250 deductible",
                "programEnrollmentRatingItemAssociationRuleId": 1,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 96,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 125,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 1,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Claims Filed Against Applicant, must provide full details",
                "programEnrollmentRatingItemAssociationRuleId": 2,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 105,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 107,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 27,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If ATA model contract is not used by applicant, they must provide contract",
                "programEnrollmentRatingItemAssociationRuleId": 3,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 92,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 93,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 26,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Evidence of E&O coverage for subcontractors, must provide % of contractors outside US",
                "programEnrollmentRatingItemAssociationRuleId": 4,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 87,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 89,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 25,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Subcontract to other, Must provide % of total income",
                "programEnrollmentRatingItemAssociationRuleId": 5,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 82,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 84,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 23,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "ATA Certified must provide Language pairs",
                "programEnrollmentRatingItemAssociationRuleId": 6,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 56,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 58,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 22,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "ATA Member must provide membership #",
                "programEnrollmentRatingItemAssociationRuleId": 7,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 52,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 54,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 21,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Insured Under Other, Carrier must be provided",
                "programEnrollmentRatingItemAssociationRuleId": 8,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 118,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 124,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 20,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Insured Under Other, Retroactive Date must be provided",
                "programEnrollmentRatingItemAssociationRuleId": 9,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 118,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 123,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 19,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Insured Under Other, Expiration Date must be provided",
                "programEnrollmentRatingItemAssociationRuleId": 10,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 118,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 122,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 18,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Insured Under Other, Policy # must be provided",
                "programEnrollmentRatingItemAssociationRuleId": 11,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 118,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 121,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 17,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Insured Under ATA, Expiration Date must be provided",
                "programEnrollmentRatingItemAssociationRuleId": 12,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 113,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 117,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 16,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Insured Under ATA, Policy # must be provided",
                "programEnrollmentRatingItemAssociationRuleId": 13,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 113,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 116,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 15,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Insured Under ATA, Retroactive Date must be provided",
                "programEnrollmentRatingItemAssociationRuleId": 14,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 113,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 115,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 14,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Rise to a claim, must provide details",
                "programEnrollmentRatingItemAssociationRuleId": 15,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 109,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 111,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 28,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Revenue > $250K cannot have a deductible of $500",
                "programEnrollmentRatingItemAssociationRuleId": 16,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 5,
                "stringComparisonValidator": "Greater",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "250000",
                "relatedProgramEnrollmentRatingItemId": 126,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 13,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItemAssociationRuleDescriptions",
                "lastUpdatedDate": "2020-02-05T00:07:24.9034002",
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Revenue<=$50K cannot have a deductible of $10K",
                "programEnrollmentRatingItemAssociationRuleId": 17,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 2,
                "stringComparisonValidator": "LessOrEqual",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "50000",
                "relatedProgramEnrollmentRatingItemId": 130,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 11,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Revenue<50K cannot have a deductible of $5000",
                "programEnrollmentRatingItemAssociationRuleId": 18,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 2,
                "stringComparisonValidator": "LessOrEqual",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "50000",
                "relatedProgramEnrollmentRatingItemId": 129,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 10,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Revenue<50K cannot have a deductible of $2500",
                "programEnrollmentRatingItemAssociationRuleId": 19,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 2,
                "stringComparisonValidator": "LessOrEqual",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "50000",
                "relatedProgramEnrollmentRatingItemId": 128,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 9,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Revenue<50K cannot have a deductible of $1000",
                "programEnrollmentRatingItemAssociationRuleId": 20,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 2,
                "stringComparisonValidator": "LessOrEqual",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "50000",
                "relatedProgramEnrollmentRatingItemId": 127,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 8,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Revenue < 50K and Limit = 500K must have a deductible of $250",
                "programEnrollmentRatingItemAssociationRuleId": 21,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 95,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 125,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 31,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItemAssociationRuleDescriptions",
                "lastUpdatedDate": "2020-02-05T00:07:25.0596185",
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "",
                "programEnrollmentRatingItemAssociationRuleId": 22,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 2,
                "stringComparisonValidator": "LessOrEqual",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "50000",
                "relatedProgramEnrollmentRatingItemId": 125,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 31,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItemAssociationRuleDescriptions",
                "lastUpdatedDate": "2020-02-05T00:07:25.0127846",
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "...Limit = 250K must have a deductible of $250",
                "programEnrollmentRatingItemAssociationRuleId": 23,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 94,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 125,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 30,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Revenue<50K and ...",
                "programEnrollmentRatingItemAssociationRuleId": 24,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 2,
                "stringComparisonValidator": "LessOrEqual",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "50000",
                "relatedProgramEnrollmentRatingItemId": 125,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 30,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "",
                "programEnrollmentRatingItemAssociationRuleId": 25,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 2,
                "stringComparisonValidator": "LessOrEqual",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "250000",
                "relatedProgramEnrollmentRatingItemId": 126,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 7,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItemAssociationRuleDescriptions",
                "lastUpdatedDate": "2020-02-05T00:07:24.9658665",
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Revenue > $50K and <= 250K must have a deductible of $500",
                "programEnrollmentRatingItemAssociationRuleId": 26,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 5,
                "stringComparisonValidator": "Greater",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "50000",
                "relatedProgramEnrollmentRatingItemId": 126,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 1,
                "stringAssociationValidator": "Has",
                "associationGroupSequence": 7,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItemAssociationRuleDescriptions",
                "lastUpdatedDate": "2020-02-05T00:07:24.9189887",
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Limit of $1M/$3M cannot be selected with $250 deductible",
                "programEnrollmentRatingItemAssociationRuleId": 27,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 99,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 125,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Limit of $1M/$2M cannot be selected with $250 deductible",
                "programEnrollmentRatingItemAssociationRuleId": 28,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 98,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 125,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 3,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Limit of $2M cannot be selected with $250 deductible",
                "programEnrollmentRatingItemAssociationRuleId": 29,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 97,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 125,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 2,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "Revenue > $250K cannot have a deductible of $250",
                "programEnrollmentRatingItemAssociationRuleId": 30,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 65,
                "comparisonValidator": 5,
                "stringComparisonValidator": "Greater",
                "targetAttributeType": 8,
                "stringTargetAttributeType": "FreeNumericInput",
                "targetValue": "250000",
                "relatedProgramEnrollmentRatingItemId": 125,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 2,
                "stringAssociationValidator": "DoesNotHave",
                "associationGroupSequence": 12,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollmentRatingItemAssociationRuleDescriptions",
                "lastUpdatedDate": "2020-02-05T00:07:24.8877632",
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "description": "If Subcontract to others then must provide info on evidence of Subcontractor E&O coverage if any",
                "programEnrollmentRatingItemAssociationRuleId": 31,
                "programEnrollmentId": 4,
                "programEnrollmentRatingItemId": 82,
                "comparisonValidator": 0,
                "stringComparisonValidator": "None",
                "targetAttributeType": 1,
                "stringTargetAttributeType": "Selected",
                "targetValue": null,
                "relatedProgramEnrollmentRatingItemId": 86,
                "relatedComparisonValidator": 0,
                "stringRelatedComparisonValidator": "None",
                "relatedTargetAttributeType": 1,
                "stringRelatedTargetAttributeType": "Selected",
                "relatedTargetValue": null,
                "associationValidator": 5,
                "stringAssociationValidator": "HasChildOf",
                "associationGroupSequence": 29,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:51.5278554",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            }
        ],
        "programEnrollmentRatingItemReferralConditionGroups": [],
        "programEnrollmentRatingGroupAssociations": [
            {
                "programEnrollmentRatingGroupAssociationId": 1,
                "programEnrollmentId": 4,
                "parentProgramEnrollmentRatingGroupId": 12,
                "childProgramEnrollmentRatingGroupId": 24,
                "associationSequence": 1,
                "parentRatingGroup": {
                    "programEnrollmentRatingGroupId": 12,
                    "programEnrollmentId": 4,
                    "ratingType": 1,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 1,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Income",
                    "specialInstruction": null,
                    "visible": true,
                    "adminVisible": true,
                    "ratingTypeDescription": "Premium",
                    "programEnrollmentRatingItems": [
                        {
                            "programEnrollmentRatingItemId": 65,
                            "programEnrollmentRatingGroupId": 12,
                            "programEnrollmentId": 4,
                            "parentItemId": null,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 1,
                            "displaySequence": 1,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": true,
                            "ratingItemId": 26,
                            "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "ratingGroupDescription": "Income",
                            "parentRatingItemDescription": "",
                            "overrideDescription": "Gross Income",
                            "parentRatingType": null,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 1,
                            "ratingType": 12,
                            "groupRatingType": 1,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "FreeNumeric",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 3,
                            "uiControl": 3,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-12-65",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": false,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": "$0.00",
                            "mask": "currency",
                            "className": null,
                            "display": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 26,
                                "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                                "lowerLimit": null,
                                "upperLimit": null,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": null,
                            "businessName": "Gross Income",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        }
                    ],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": false,
                    "validationTarget": null,
                    "excludeFromReportFlag": false,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": false,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "childRatingGroup": {
                    "programEnrollmentRatingGroupId": 24,
                    "programEnrollmentId": 4,
                    "ratingType": 33,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 15,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Revenue Bands",
                    "specialInstruction": null,
                    "visible": false,
                    "adminVisible": false,
                    "ratingTypeDescription": "Band",
                    "programEnrollmentRatingItems": [],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": false,
                    "validationTarget": null,
                    "excludeFromReportFlag": false,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": false,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.2909593",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupAssociationId": 2,
                "programEnrollmentId": 4,
                "parentProgramEnrollmentRatingGroupId": 12,
                "childProgramEnrollmentRatingGroupId": 17,
                "associationSequence": 2,
                "parentRatingGroup": {
                    "programEnrollmentRatingGroupId": 12,
                    "programEnrollmentId": 4,
                    "ratingType": 1,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 1,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Income",
                    "specialInstruction": null,
                    "visible": true,
                    "adminVisible": true,
                    "ratingTypeDescription": "Premium",
                    "programEnrollmentRatingItems": [
                        {
                            "programEnrollmentRatingItemId": 65,
                            "programEnrollmentRatingGroupId": 12,
                            "programEnrollmentId": 4,
                            "parentItemId": null,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 1,
                            "displaySequence": 1,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": true,
                            "ratingItemId": 26,
                            "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "ratingGroupDescription": "Income",
                            "parentRatingItemDescription": "",
                            "overrideDescription": "Gross Income",
                            "parentRatingType": null,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 1,
                            "ratingType": 12,
                            "groupRatingType": 1,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "FreeNumeric",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 3,
                            "uiControl": 3,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-12-65",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": false,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": "$0.00",
                            "mask": "currency",
                            "className": null,
                            "display": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 26,
                                "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                                "lowerLimit": null,
                                "upperLimit": null,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": null,
                            "businessName": "Gross Income",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        }
                    ],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": false,
                    "validationTarget": null,
                    "excludeFromReportFlag": false,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": false,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "childRatingGroup": {
                    "programEnrollmentRatingGroupId": 17,
                    "programEnrollmentId": 4,
                    "ratingType": 31,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 2,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Limits of liability",
                    "specialInstruction": null,
                    "visible": true,
                    "adminVisible": true,
                    "ratingTypeDescription": "Factor",
                    "programEnrollmentRatingItems": [
                        {
                            "programEnrollmentRatingItemId": 192,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": null,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 0,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": 1,
                            "maxSelection": 1,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 9995,
                            "ratingItemDescription": "Top level item of a selection (Parent)",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "",
                            "overrideDescription": "Limits of liability",
                            "parentRatingType": null,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 0,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "None",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 5,
                            "uiControl": 5,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-192",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": "Available limits based on income...",
                            "mask": null,
                            "className": null,
                            "display": "Limits of liability",
                            "relatedItems": [
                                {
                                    "programEnrollmentRatingItemId": 94,
                                    "programEnrollmentRatingGroupId": 17,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 192,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 2,
                                    "displaySequence": 1,
                                    "premium": 0,
                                    "deductible": null,
                                    "factor": 0.625,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": 6,
                                    "upperLimitCoverageTypeId": 1,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 48,
                                    "ratingItemDescription": "$250,000",
                                    "ratingGroupDescription": "Limits of liability",
                                    "parentRatingItemDescription": "Limits of liability",
                                    "overrideDescription": "$250,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-17-94",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$250,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 48,
                                        "ratingItemDescription": "$250,000",
                                        "lowerLimit": 250000,
                                        "upperLimit": 250000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "0.62500000000000000000",
                                    "businessName": "$250,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 95,
                                    "programEnrollmentRatingGroupId": 17,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 192,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 2,
                                    "displaySequence": 2,
                                    "premium": 0,
                                    "deductible": null,
                                    "factor": 0.875,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": 6,
                                    "upperLimitCoverageTypeId": 1,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 49,
                                    "ratingItemDescription": "$500,000",
                                    "ratingGroupDescription": "Limits of liability",
                                    "parentRatingItemDescription": "Limits of liability",
                                    "overrideDescription": "$500,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-17-95",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$500,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 49,
                                        "ratingItemDescription": "$500,000",
                                        "lowerLimit": 500000,
                                        "upperLimit": 500000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "0.87500000000000000000",
                                    "businessName": "$500,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 96,
                                    "programEnrollmentRatingGroupId": 17,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 192,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 2,
                                    "displaySequence": 3,
                                    "premium": 0,
                                    "deductible": null,
                                    "factor": 1,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": 6,
                                    "upperLimitCoverageTypeId": 1,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 50,
                                    "ratingItemDescription": "$1,000,000",
                                    "ratingGroupDescription": "Limits of liability",
                                    "parentRatingItemDescription": "Limits of liability",
                                    "overrideDescription": "$1,000,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-17-96",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$1,000,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 50,
                                        "ratingItemDescription": "$1,000,000",
                                        "lowerLimit": 1000000,
                                        "upperLimit": 1000000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "1.00000000000000000000",
                                    "businessName": "$1,000,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 97,
                                    "programEnrollmentRatingGroupId": 17,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 192,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 2,
                                    "displaySequence": 4,
                                    "premium": 0,
                                    "deductible": null,
                                    "factor": 1.45,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": 6,
                                    "upperLimitCoverageTypeId": 1,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 51,
                                    "ratingItemDescription": "$2,000,000",
                                    "ratingGroupDescription": "Limits of liability",
                                    "parentRatingItemDescription": "Limits of liability",
                                    "overrideDescription": "$2,000,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-17-97",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$2,000,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 51,
                                        "ratingItemDescription": "$2,000,000",
                                        "lowerLimit": 2000000,
                                        "upperLimit": 2000000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "1.45000000000000000000",
                                    "businessName": "$2,000,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 98,
                                    "programEnrollmentRatingGroupId": 17,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 192,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 2,
                                    "displaySequence": 5,
                                    "premium": 0,
                                    "deductible": null,
                                    "factor": 1.2,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": 6,
                                    "upperLimitCoverageTypeId": 1,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 70,
                                    "ratingItemDescription": "$1,000,000 / $2,000,000",
                                    "ratingGroupDescription": "Limits of liability",
                                    "parentRatingItemDescription": "Limits of liability",
                                    "overrideDescription": "$1,000,000 / $2,000,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-17-98",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$1,000,000 / $2,000,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 70,
                                        "ratingItemDescription": "$1,000,000 / $2,000,000",
                                        "lowerLimit": 1000000,
                                        "upperLimit": 2000000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "1.20000000000000000000",
                                    "businessName": "$1,000,000 / $2,000,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 99,
                                    "programEnrollmentRatingGroupId": 17,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 192,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 2,
                                    "displaySequence": 6,
                                    "premium": 0,
                                    "deductible": null,
                                    "factor": 1.35,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": 6,
                                    "upperLimitCoverageTypeId": 1,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 71,
                                    "ratingItemDescription": "$1,000,000 / $3,000,000",
                                    "ratingGroupDescription": "Limits of liability",
                                    "parentRatingItemDescription": "Limits of liability",
                                    "overrideDescription": "$1,000,000 / $3,000,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-17-99",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$1,000,000 / $3,000,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 71,
                                        "ratingItemDescription": "$1,000,000 / $3,000,000",
                                        "lowerLimit": 1000000,
                                        "upperLimit": 3000000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "1.35000000000000000000",
                                    "businessName": "$1,000,000 / $3,000,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 187,
                                    "programEnrollmentRatingGroupId": 17,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 192,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 2,
                                    "displaySequence": 7,
                                    "premium": 0,
                                    "deductible": null,
                                    "factor": 0,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": 6,
                                    "upperLimitCoverageTypeId": 1,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 78,
                                    "ratingItemDescription": "$3,000,000",
                                    "ratingGroupDescription": "Limits of liability",
                                    "parentRatingItemDescription": "Limits of liability",
                                    "overrideDescription": "$3,000,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-17-187",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$3,000,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 78,
                                        "ratingItemDescription": "$3,000,000",
                                        "lowerLimit": 3000000,
                                        "upperLimit": 3000000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "0.00000000000000000000",
                                    "businessName": "$3,000,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 188,
                                    "programEnrollmentRatingGroupId": 17,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 192,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 2,
                                    "displaySequence": 8,
                                    "premium": 0,
                                    "deductible": null,
                                    "factor": 0,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": 6,
                                    "upperLimitCoverageTypeId": 1,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 77,
                                    "ratingItemDescription": "$5,000,000",
                                    "ratingGroupDescription": "Limits of liability",
                                    "parentRatingItemDescription": "Limits of liability",
                                    "overrideDescription": "$5,000,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-17-188",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$5,000,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 77,
                                        "ratingItemDescription": "$5,000,000",
                                        "lowerLimit": 5000000,
                                        "upperLimit": 5000000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "0.00000000000000000000",
                                    "businessName": "$5,000,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                }
                            ],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 9995,
                                "ratingItemDescription": "Top level item of a selection (Parent)",
                                "lowerLimit": null,
                                "upperLimit": null,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": true,
                            "intrinsicValue": null,
                            "businessName": "Limits of liability",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 94,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 1,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0.625,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 48,
                            "ratingItemDescription": "$250,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$250,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-94",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$250,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 48,
                                "ratingItemDescription": "$250,000",
                                "lowerLimit": 250000,
                                "upperLimit": 250000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.62500000000000000000",
                            "businessName": "$250,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 94,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 1,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0.625,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 48,
                            "ratingItemDescription": "$250,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$250,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-94",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$250,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 48,
                                "ratingItemDescription": "$250,000",
                                "lowerLimit": 250000,
                                "upperLimit": 250000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.62500000000000000000",
                            "businessName": "$250,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 95,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 2,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0.875,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 49,
                            "ratingItemDescription": "$500,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$500,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-95",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$500,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 49,
                                "ratingItemDescription": "$500,000",
                                "lowerLimit": 500000,
                                "upperLimit": 500000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.87500000000000000000",
                            "businessName": "$500,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 95,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 2,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0.875,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 49,
                            "ratingItemDescription": "$500,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$500,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-95",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$500,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 49,
                                "ratingItemDescription": "$500,000",
                                "lowerLimit": 500000,
                                "upperLimit": 500000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.87500000000000000000",
                            "businessName": "$500,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 96,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 3,
                            "premium": 0,
                            "deductible": null,
                            "factor": 1,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 50,
                            "ratingItemDescription": "$1,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$1,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-96",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$1,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 50,
                                "ratingItemDescription": "$1,000,000",
                                "lowerLimit": 1000000,
                                "upperLimit": 1000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.00000000000000000000",
                            "businessName": "$1,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 96,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 3,
                            "premium": 0,
                            "deductible": null,
                            "factor": 1,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 50,
                            "ratingItemDescription": "$1,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$1,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-96",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$1,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 50,
                                "ratingItemDescription": "$1,000,000",
                                "lowerLimit": 1000000,
                                "upperLimit": 1000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.00000000000000000000",
                            "businessName": "$1,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 97,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 4,
                            "premium": 0,
                            "deductible": null,
                            "factor": 1.45,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 51,
                            "ratingItemDescription": "$2,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$2,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-97",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$2,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 51,
                                "ratingItemDescription": "$2,000,000",
                                "lowerLimit": 2000000,
                                "upperLimit": 2000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.45000000000000000000",
                            "businessName": "$2,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 97,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 4,
                            "premium": 0,
                            "deductible": null,
                            "factor": 1.45,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 51,
                            "ratingItemDescription": "$2,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$2,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-97",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$2,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 51,
                                "ratingItemDescription": "$2,000,000",
                                "lowerLimit": 2000000,
                                "upperLimit": 2000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.45000000000000000000",
                            "businessName": "$2,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 98,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 5,
                            "premium": 0,
                            "deductible": null,
                            "factor": 1.2,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 70,
                            "ratingItemDescription": "$1,000,000 / $2,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$1,000,000 / $2,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-98",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$1,000,000 / $2,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 70,
                                "ratingItemDescription": "$1,000,000 / $2,000,000",
                                "lowerLimit": 1000000,
                                "upperLimit": 2000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.20000000000000000000",
                            "businessName": "$1,000,000 / $2,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 98,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 5,
                            "premium": 0,
                            "deductible": null,
                            "factor": 1.2,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 70,
                            "ratingItemDescription": "$1,000,000 / $2,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$1,000,000 / $2,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-98",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$1,000,000 / $2,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 70,
                                "ratingItemDescription": "$1,000,000 / $2,000,000",
                                "lowerLimit": 1000000,
                                "upperLimit": 2000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.20000000000000000000",
                            "businessName": "$1,000,000 / $2,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 99,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 6,
                            "premium": 0,
                            "deductible": null,
                            "factor": 1.35,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 71,
                            "ratingItemDescription": "$1,000,000 / $3,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$1,000,000 / $3,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-99",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$1,000,000 / $3,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 71,
                                "ratingItemDescription": "$1,000,000 / $3,000,000",
                                "lowerLimit": 1000000,
                                "upperLimit": 3000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.35000000000000000000",
                            "businessName": "$1,000,000 / $3,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 99,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 6,
                            "premium": 0,
                            "deductible": null,
                            "factor": 1.35,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 71,
                            "ratingItemDescription": "$1,000,000 / $3,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$1,000,000 / $3,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-99",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$1,000,000 / $3,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 71,
                                "ratingItemDescription": "$1,000,000 / $3,000,000",
                                "lowerLimit": 1000000,
                                "upperLimit": 3000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.35000000000000000000",
                            "businessName": "$1,000,000 / $3,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 187,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 7,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 78,
                            "ratingItemDescription": "$3,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$3,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-187",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$3,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 78,
                                "ratingItemDescription": "$3,000,000",
                                "lowerLimit": 3000000,
                                "upperLimit": 3000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.00000000000000000000",
                            "businessName": "$3,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 187,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 7,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 78,
                            "ratingItemDescription": "$3,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$3,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-187",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$3,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 78,
                                "ratingItemDescription": "$3,000,000",
                                "lowerLimit": 3000000,
                                "upperLimit": 3000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.00000000000000000000",
                            "businessName": "$3,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 188,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 8,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 77,
                            "ratingItemDescription": "$5,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$5,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-188",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$5,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 77,
                                "ratingItemDescription": "$5,000,000",
                                "lowerLimit": 5000000,
                                "upperLimit": 5000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.00000000000000000000",
                            "businessName": "$5,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 188,
                            "programEnrollmentRatingGroupId": 17,
                            "programEnrollmentId": 4,
                            "parentItemId": 192,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 2,
                            "displaySequence": 8,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": 6,
                            "upperLimitCoverageTypeId": 1,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 77,
                            "ratingItemDescription": "$5,000,000",
                            "ratingGroupDescription": "Limits of liability",
                            "parentRatingItemDescription": "Limits of liability",
                            "overrideDescription": "$5,000,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-17-188",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$5,000,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 77,
                                "ratingItemDescription": "$5,000,000",
                                "lowerLimit": 5000000,
                                "upperLimit": 5000000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.00000000000000000000",
                            "businessName": "$5,000,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        }
                    ],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": false,
                    "validationTarget": null,
                    "excludeFromReportFlag": true,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": false,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.2909593",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupAssociationId": 3,
                "programEnrollmentId": 4,
                "parentProgramEnrollmentRatingGroupId": 12,
                "childProgramEnrollmentRatingGroupId": 23,
                "associationSequence": 3,
                "parentRatingGroup": {
                    "programEnrollmentRatingGroupId": 12,
                    "programEnrollmentId": 4,
                    "ratingType": 1,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 1,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Income",
                    "specialInstruction": null,
                    "visible": true,
                    "adminVisible": true,
                    "ratingTypeDescription": "Premium",
                    "programEnrollmentRatingItems": [
                        {
                            "programEnrollmentRatingItemId": 65,
                            "programEnrollmentRatingGroupId": 12,
                            "programEnrollmentId": 4,
                            "parentItemId": null,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 1,
                            "displaySequence": 1,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": true,
                            "ratingItemId": 26,
                            "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "ratingGroupDescription": "Income",
                            "parentRatingItemDescription": "",
                            "overrideDescription": "Gross Income",
                            "parentRatingType": null,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 1,
                            "ratingType": 12,
                            "groupRatingType": 1,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "FreeNumeric",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 3,
                            "uiControl": 3,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-12-65",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": false,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": "$0.00",
                            "mask": "currency",
                            "className": null,
                            "display": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 26,
                                "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                                "lowerLimit": null,
                                "upperLimit": null,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": null,
                            "businessName": "Gross Income",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        }
                    ],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": false,
                    "validationTarget": null,
                    "excludeFromReportFlag": false,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": false,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "childRatingGroup": {
                    "programEnrollmentRatingGroupId": 23,
                    "programEnrollmentId": 4,
                    "ratingType": 31,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 3,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Deductibles",
                    "specialInstruction": null,
                    "visible": true,
                    "adminVisible": true,
                    "ratingTypeDescription": "Factor",
                    "programEnrollmentRatingItems": [
                        {
                            "programEnrollmentRatingItemId": 193,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": null,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 0,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": 1,
                            "maxSelection": 1,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 9995,
                            "ratingItemDescription": "Top level item of a selection (Parent)",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "",
                            "overrideDescription": "Deductibles",
                            "parentRatingType": null,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 0,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "None",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 5,
                            "uiControl": 5,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-193",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": "Available deductibles based on limit...",
                            "mask": null,
                            "className": null,
                            "display": "Deductibles",
                            "relatedItems": [
                                {
                                    "programEnrollmentRatingItemId": 125,
                                    "programEnrollmentRatingGroupId": 23,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 193,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 3,
                                    "displaySequence": 1,
                                    "premium": 0,
                                    "deductible": 250,
                                    "factor": 1.05,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": null,
                                    "upperLimitCoverageTypeId": null,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 63,
                                    "ratingItemDescription": "$250",
                                    "ratingGroupDescription": "Deductibles",
                                    "parentRatingItemDescription": "Deductibles",
                                    "overrideDescription": "$250",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-23-125",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$250",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 63,
                                        "ratingItemDescription": "$250",
                                        "lowerLimit": null,
                                        "upperLimit": 250,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "1.05000000000000000000",
                                    "businessName": "$250",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 126,
                                    "programEnrollmentRatingGroupId": 23,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 193,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 3,
                                    "displaySequence": 2,
                                    "premium": 0,
                                    "deductible": 500,
                                    "factor": 1,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": null,
                                    "upperLimitCoverageTypeId": null,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 64,
                                    "ratingItemDescription": "$500",
                                    "ratingGroupDescription": "Deductibles",
                                    "parentRatingItemDescription": "Deductibles",
                                    "overrideDescription": "$500",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-23-126",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$500",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 64,
                                        "ratingItemDescription": "$500",
                                        "lowerLimit": null,
                                        "upperLimit": 500,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "1.00000000000000000000",
                                    "businessName": "$500",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 127,
                                    "programEnrollmentRatingGroupId": 23,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 193,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 3,
                                    "displaySequence": 3,
                                    "premium": 0,
                                    "deductible": 1000,
                                    "factor": 0.925,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": null,
                                    "upperLimitCoverageTypeId": null,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 65,
                                    "ratingItemDescription": "$1,000",
                                    "ratingGroupDescription": "Deductibles",
                                    "parentRatingItemDescription": "Deductibles",
                                    "overrideDescription": "$1,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-23-127",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$1,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 65,
                                        "ratingItemDescription": "$1,000",
                                        "lowerLimit": null,
                                        "upperLimit": 1000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "0.92500000000000000000",
                                    "businessName": "$1,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 128,
                                    "programEnrollmentRatingGroupId": 23,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 193,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 3,
                                    "displaySequence": 4,
                                    "premium": 0,
                                    "deductible": 2500,
                                    "factor": 0.875,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": null,
                                    "upperLimitCoverageTypeId": null,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 66,
                                    "ratingItemDescription": "$2,500",
                                    "ratingGroupDescription": "Deductibles",
                                    "parentRatingItemDescription": "Deductibles",
                                    "overrideDescription": "$2,500",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-23-128",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$2,500",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 66,
                                        "ratingItemDescription": "$2,500",
                                        "lowerLimit": null,
                                        "upperLimit": 2500,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "0.87500000000000000000",
                                    "businessName": "$2,500",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 129,
                                    "programEnrollmentRatingGroupId": 23,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 193,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 3,
                                    "displaySequence": 5,
                                    "premium": 0,
                                    "deductible": 5000,
                                    "factor": 0.825,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": null,
                                    "upperLimitCoverageTypeId": null,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 67,
                                    "ratingItemDescription": "$5,000",
                                    "ratingGroupDescription": "Deductibles",
                                    "parentRatingItemDescription": "Deductibles",
                                    "overrideDescription": "$5,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-23-129",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$5,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 67,
                                        "ratingItemDescription": "$5,000",
                                        "lowerLimit": null,
                                        "upperLimit": 5000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "0.82500000000000000000",
                                    "businessName": "$5,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                },
                                {
                                    "programEnrollmentRatingItemId": 130,
                                    "programEnrollmentRatingGroupId": 23,
                                    "programEnrollmentId": 4,
                                    "parentItemId": 193,
                                    "sectionDisplaySequence": null,
                                    "groupDisplaySequence": 3,
                                    "displaySequence": 6,
                                    "premium": 0,
                                    "deductible": 10000,
                                    "factor": 0.775,
                                    "lowerLimit": null,
                                    "upperLimit": null,
                                    "lowerStringLimit": null,
                                    "upperStringLimit": null,
                                    "minSelection": null,
                                    "maxSelection": null,
                                    "lowerLimitCoverageTypeId": null,
                                    "upperLimitCoverageTypeId": null,
                                    "agencyFee": null,
                                    "isFactorable": false,
                                    "ratingItemId": 68,
                                    "ratingItemDescription": "$10,000",
                                    "ratingGroupDescription": "Deductibles",
                                    "parentRatingItemDescription": "Deductibles",
                                    "overrideDescription": "$10,000",
                                    "parentRatingType": 0,
                                    "specialInstruction": null,
                                    "defaultSelectedState": false,
                                    "value": null,
                                    "numericDataType": 0,
                                    "ratingType": 31,
                                    "groupRatingType": 31,
                                    "conditional": false,
                                    "functionType": 0,
                                    "stringFunctionType": "None",
                                    "programEnrollmentDocumentId": null,
                                    "programEnrollmentDocument": null,
                                    "stringRatingType": "Factor",
                                    "minPremium": null,
                                    "maxPremium": null,
                                    "uiIsRequired": null,
                                    "uiIsReadonly": null,
                                    "uiControlId": 8,
                                    "uiControl": 8,
                                    "uiControlAggregateFunctionId": null,
                                    "uiControlAggregateFunction": 0,
                                    "stringUiControlAggregateFunction": "None",
                                    "validationTargetValue": null,
                                    "validationTargetItemId": null,
                                    "sectionId": null,
                                    "sectionName": null,
                                    "sectionIndicator": false,
                                    "uniqueIdentifier": "4-23-130",
                                    "visible": true,
                                    "adminVisible": true,
                                    "excludeFromReport": true,
                                    "semanticItemId": null,
                                    "semanticParentItemId": null,
                                    "hint": null,
                                    "placeHolder": null,
                                    "mask": null,
                                    "className": null,
                                    "display": "$10,000",
                                    "relatedItems": [],
                                    "isDefault": false,
                                    "ratingItem": {
                                        "ratingItemId": 68,
                                        "ratingItemDescription": "$10,000",
                                        "lowerLimit": null,
                                        "upperLimit": 10000,
                                        "createUser": "Migration.Seeder",
                                        "createDate": "2020-02-05T00:05:03.7219203",
                                        "lastUpdatedUser": null,
                                        "lastUpdatedDate": null,
                                        "disabled": false,
                                        "systemNotes": null,
                                        "userEmail": null,
                                        "errors": [],
                                        "isSuccessful": true
                                    },
                                    "hasChildren": false,
                                    "intrinsicValue": "0.77500000000000000000",
                                    "businessName": "$10,000",
                                    "createUser": "Migration.Seeder",
                                    "createDate": "2020-02-05T00:05:25.7004791",
                                    "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                                    "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                                    "disabled": false,
                                    "systemNotes": null,
                                    "userEmail": null,
                                    "errors": [],
                                    "isSuccessful": true
                                }
                            ],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 9995,
                                "ratingItemDescription": "Top level item of a selection (Parent)",
                                "lowerLimit": null,
                                "upperLimit": null,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": true,
                            "intrinsicValue": null,
                            "businessName": "Deductibles",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 125,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 1,
                            "premium": 0,
                            "deductible": 250,
                            "factor": 1.05,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 63,
                            "ratingItemDescription": "$250",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$250",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-125",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$250",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 63,
                                "ratingItemDescription": "$250",
                                "lowerLimit": null,
                                "upperLimit": 250,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.05000000000000000000",
                            "businessName": "$250",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 125,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 1,
                            "premium": 0,
                            "deductible": 250,
                            "factor": 1.05,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 63,
                            "ratingItemDescription": "$250",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$250",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-125",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$250",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 63,
                                "ratingItemDescription": "$250",
                                "lowerLimit": null,
                                "upperLimit": 250,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.05000000000000000000",
                            "businessName": "$250",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 126,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 2,
                            "premium": 0,
                            "deductible": 500,
                            "factor": 1,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 64,
                            "ratingItemDescription": "$500",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$500",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-126",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$500",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 64,
                                "ratingItemDescription": "$500",
                                "lowerLimit": null,
                                "upperLimit": 500,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.00000000000000000000",
                            "businessName": "$500",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 126,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 2,
                            "premium": 0,
                            "deductible": 500,
                            "factor": 1,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 64,
                            "ratingItemDescription": "$500",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$500",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-126",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$500",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 64,
                                "ratingItemDescription": "$500",
                                "lowerLimit": null,
                                "upperLimit": 500,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "1.00000000000000000000",
                            "businessName": "$500",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 127,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 3,
                            "premium": 0,
                            "deductible": 1000,
                            "factor": 0.925,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 65,
                            "ratingItemDescription": "$1,000",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$1,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-127",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$1,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 65,
                                "ratingItemDescription": "$1,000",
                                "lowerLimit": null,
                                "upperLimit": 1000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.92500000000000000000",
                            "businessName": "$1,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 127,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 3,
                            "premium": 0,
                            "deductible": 1000,
                            "factor": 0.925,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 65,
                            "ratingItemDescription": "$1,000",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$1,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-127",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$1,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 65,
                                "ratingItemDescription": "$1,000",
                                "lowerLimit": null,
                                "upperLimit": 1000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.92500000000000000000",
                            "businessName": "$1,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 128,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 4,
                            "premium": 0,
                            "deductible": 2500,
                            "factor": 0.875,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 66,
                            "ratingItemDescription": "$2,500",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$2,500",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-128",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$2,500",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 66,
                                "ratingItemDescription": "$2,500",
                                "lowerLimit": null,
                                "upperLimit": 2500,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.87500000000000000000",
                            "businessName": "$2,500",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 128,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 4,
                            "premium": 0,
                            "deductible": 2500,
                            "factor": 0.875,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 66,
                            "ratingItemDescription": "$2,500",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$2,500",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-128",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$2,500",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 66,
                                "ratingItemDescription": "$2,500",
                                "lowerLimit": null,
                                "upperLimit": 2500,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.87500000000000000000",
                            "businessName": "$2,500",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 129,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 5,
                            "premium": 0,
                            "deductible": 5000,
                            "factor": 0.825,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 67,
                            "ratingItemDescription": "$5,000",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$5,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-129",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$5,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 67,
                                "ratingItemDescription": "$5,000",
                                "lowerLimit": null,
                                "upperLimit": 5000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.82500000000000000000",
                            "businessName": "$5,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 129,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 5,
                            "premium": 0,
                            "deductible": 5000,
                            "factor": 0.825,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 67,
                            "ratingItemDescription": "$5,000",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$5,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-129",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$5,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 67,
                                "ratingItemDescription": "$5,000",
                                "lowerLimit": null,
                                "upperLimit": 5000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.82500000000000000000",
                            "businessName": "$5,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 130,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 6,
                            "premium": 0,
                            "deductible": 10000,
                            "factor": 0.775,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 68,
                            "ratingItemDescription": "$10,000",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$10,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-130",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$10,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 68,
                                "ratingItemDescription": "$10,000",
                                "lowerLimit": null,
                                "upperLimit": 10000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.77500000000000000000",
                            "businessName": "$10,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        },
                        {
                            "programEnrollmentRatingItemId": 130,
                            "programEnrollmentRatingGroupId": 23,
                            "programEnrollmentId": 4,
                            "parentItemId": 193,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 3,
                            "displaySequence": 6,
                            "premium": 0,
                            "deductible": 10000,
                            "factor": 0.775,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": false,
                            "ratingItemId": 68,
                            "ratingItemDescription": "$10,000",
                            "ratingGroupDescription": "Deductibles",
                            "parentRatingItemDescription": "Deductibles",
                            "overrideDescription": "$10,000",
                            "parentRatingType": 0,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 0,
                            "ratingType": 31,
                            "groupRatingType": 31,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "Factor",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 8,
                            "uiControl": 8,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-23-130",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": true,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": null,
                            "mask": null,
                            "className": null,
                            "display": "$10,000",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 68,
                                "ratingItemDescription": "$10,000",
                                "lowerLimit": null,
                                "upperLimit": 10000,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": "0.77500000000000000000",
                            "businessName": "$10,000",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        }
                    ],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": true,
                    "validationTarget": null,
                    "excludeFromReportFlag": true,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": false,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.2909593",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupAssociationId": 4,
                "programEnrollmentId": 4,
                "parentProgramEnrollmentRatingGroupId": 12,
                "childProgramEnrollmentRatingGroupId": 27,
                "associationSequence": 4,
                "parentRatingGroup": {
                    "programEnrollmentRatingGroupId": 12,
                    "programEnrollmentId": 4,
                    "ratingType": 1,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 1,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Income",
                    "specialInstruction": null,
                    "visible": true,
                    "adminVisible": true,
                    "ratingTypeDescription": "Premium",
                    "programEnrollmentRatingItems": [
                        {
                            "programEnrollmentRatingItemId": 65,
                            "programEnrollmentRatingGroupId": 12,
                            "programEnrollmentId": 4,
                            "parentItemId": null,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 1,
                            "displaySequence": 1,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": true,
                            "ratingItemId": 26,
                            "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "ratingGroupDescription": "Income",
                            "parentRatingItemDescription": "",
                            "overrideDescription": "Gross Income",
                            "parentRatingType": null,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 1,
                            "ratingType": 12,
                            "groupRatingType": 1,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "FreeNumeric",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 3,
                            "uiControl": 3,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-12-65",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": false,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": "$0.00",
                            "mask": "currency",
                            "className": null,
                            "display": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 26,
                                "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                                "lowerLimit": null,
                                "upperLimit": null,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": null,
                            "businessName": "Gross Income",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        }
                    ],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": false,
                    "validationTarget": null,
                    "excludeFromReportFlag": false,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": false,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "childRatingGroup": {
                    "programEnrollmentRatingGroupId": 27,
                    "programEnrollmentId": 4,
                    "ratingType": 31,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 18,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Conditional Group",
                    "specialInstruction": null,
                    "visible": false,
                    "adminVisible": false,
                    "ratingTypeDescription": "Factor",
                    "programEnrollmentRatingItems": [],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": false,
                    "validationTarget": null,
                    "excludeFromReportFlag": true,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": true,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.2909593",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentRatingGroupAssociationId": 5,
                "programEnrollmentId": 4,
                "parentProgramEnrollmentRatingGroupId": 12,
                "childProgramEnrollmentRatingGroupId": 28,
                "associationSequence": 5,
                "parentRatingGroup": {
                    "programEnrollmentRatingGroupId": 12,
                    "programEnrollmentId": 4,
                    "ratingType": 1,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 1,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Income",
                    "specialInstruction": null,
                    "visible": true,
                    "adminVisible": true,
                    "ratingTypeDescription": "Premium",
                    "programEnrollmentRatingItems": [
                        {
                            "programEnrollmentRatingItemId": 65,
                            "programEnrollmentRatingGroupId": 12,
                            "programEnrollmentId": 4,
                            "parentItemId": null,
                            "sectionDisplaySequence": null,
                            "groupDisplaySequence": 1,
                            "displaySequence": 1,
                            "premium": 0,
                            "deductible": null,
                            "factor": 0,
                            "lowerLimit": null,
                            "upperLimit": null,
                            "lowerStringLimit": null,
                            "upperStringLimit": null,
                            "minSelection": null,
                            "maxSelection": null,
                            "lowerLimitCoverageTypeId": null,
                            "upperLimitCoverageTypeId": null,
                            "agencyFee": null,
                            "isFactorable": true,
                            "ratingItemId": 26,
                            "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "ratingGroupDescription": "Income",
                            "parentRatingItemDescription": "",
                            "overrideDescription": "Gross Income",
                            "parentRatingType": null,
                            "specialInstruction": null,
                            "defaultSelectedState": false,
                            "value": null,
                            "numericDataType": 1,
                            "ratingType": 12,
                            "groupRatingType": 1,
                            "conditional": false,
                            "functionType": 0,
                            "stringFunctionType": "None",
                            "programEnrollmentDocumentId": null,
                            "programEnrollmentDocument": null,
                            "stringRatingType": "FreeNumeric",
                            "minPremium": null,
                            "maxPremium": null,
                            "uiIsRequired": null,
                            "uiIsReadonly": null,
                            "uiControlId": 3,
                            "uiControl": 3,
                            "uiControlAggregateFunctionId": null,
                            "uiControlAggregateFunction": 0,
                            "stringUiControlAggregateFunction": "None",
                            "validationTargetValue": null,
                            "validationTargetItemId": null,
                            "sectionId": null,
                            "sectionName": null,
                            "sectionIndicator": false,
                            "uniqueIdentifier": "4-12-65",
                            "visible": true,
                            "adminVisible": true,
                            "excludeFromReport": false,
                            "semanticItemId": null,
                            "semanticParentItemId": null,
                            "hint": null,
                            "placeHolder": "$0.00",
                            "mask": "currency",
                            "className": null,
                            "display": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                            "relatedItems": [],
                            "isDefault": false,
                            "ratingItem": {
                                "ratingItemId": 26,
                                "ratingItemDescription": "Total gross income from translation and interpretation services for the previous 12 months * (Startups must furnish projected figure for first year):",
                                "lowerLimit": null,
                                "upperLimit": null,
                                "createUser": "Migration.Seeder",
                                "createDate": "2020-02-05T00:05:03.7219203",
                                "lastUpdatedUser": null,
                                "lastUpdatedDate": null,
                                "disabled": false,
                                "systemNotes": null,
                                "userEmail": null,
                                "errors": [],
                                "isSuccessful": true
                            },
                            "hasChildren": false,
                            "intrinsicValue": null,
                            "businessName": "Gross Income",
                            "createUser": "Migration.Seeder",
                            "createDate": "2020-02-05T00:05:25.7004791",
                            "lastUpdatedUser": "Seed.UpdateUniqueIdentifiers",
                            "lastUpdatedDate": "2020-02-05T00:07:08.9747755",
                            "disabled": false,
                            "systemNotes": null,
                            "userEmail": null,
                            "errors": [],
                            "isSuccessful": true
                        }
                    ],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": false,
                    "validationTarget": null,
                    "excludeFromReportFlag": false,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": false,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "childRatingGroup": {
                    "programEnrollmentRatingGroupId": 28,
                    "programEnrollmentId": 4,
                    "ratingType": 35,
                    "overrideDescription": null,
                    "sectionDisplaySequence": 0,
                    "displaySequence": 19,
                    "minSelection": null,
                    "maxSelection": null,
                    "ratingGroupDescription": "Function Group (Round To Nearest $)",
                    "specialInstruction": null,
                    "visible": false,
                    "adminVisible": false,
                    "ratingTypeDescription": "Function",
                    "programEnrollmentRatingItems": [],
                    "programEnrollmentRatingGroupContents": [],
                    "hasDeductible": false,
                    "validationTarget": null,
                    "excludeFromReportFlag": true,
                    "sectionId": null,
                    "sectionName": null,
                    "sectionIndicator": false,
                    "conditional": true,
                    "className": null,
                    "display": null,
                    "createUser": "Migration.Seeder",
                    "createDate": "2020-02-05T00:05:24.9030888",
                    "lastUpdatedUser": null,
                    "lastUpdatedDate": null,
                    "disabled": false,
                    "systemNotes": null,
                    "userEmail": null,
                    "errors": [],
                    "isSuccessful": true
                },
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.2909593",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            }
        ],
        "programEnrollmentRatingGroupAssociationRules": [],
        "programEnrollmentContents": [
            {
                "programEnrollmentContentId": 28,
                "displaySequence": 1,
                "content": "<p>We make the process of finding the right professional liability insurance coverage as quick and easy as possible. We can work with you to provide professional liability insurance quotes.</p>",
                "contentSectionTypeId": 1,
                "contentSectionType": "Header",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 29,
                "displaySequence": 1,
                "content": "<font color='red'><strong>Not ready to pay? Select ‘Cancel’ then ‘save quote’ to pay at a later time<strong></font><br />",
                "contentSectionTypeId": 15,
                "contentSectionType": "PremiumFinanceFooter",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 30,
                "displaySequence": 1,
                "content": "<font color='red'><strong>Not ready to pay? Select ‘Cancel’ then ‘save quote’ to pay at a later time<strong></font><br />",
                "contentSectionTypeId": 27,
                "contentSectionType": "AchFooter",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 31,
                "displaySequence": 1,
                "content": "<font color='red'><strong>Not ready to pay? Select ‘Cancel’ then ‘save quote’ to pay at a later time<strong></font><br />",
                "contentSectionTypeId": 21,
                "contentSectionType": "CreditCardFooter",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 32,
                "displaySequence": 2,
                "content": "<p class='text-danger'><strong>Please check the above application to make sure all spelling of names, company, street, city, state, e-mail, phone numbers, etc and information on the application are correct before submitting. Thank you.<strong></p>",
                "contentSectionTypeId": 3,
                "contentSectionType": "Footer",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 33,
                "displaySequence": 1,
                "content": "Applicant represents and warrants to the best of their knowledge that the particulars and statements contained in this application are true and agree that these particulars and statements are the basis of the policy that may be issued, and will constitute a part of the policy. By Submitting this Application, the Applicant agrees that in the event the application contains misrepresentations or fails to state facts materially affecting the risk assumed by the insuring company under a policy issued, the policy may be deemed null and void.",
                "contentSectionTypeId": 3,
                "contentSectionType": "Footer",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 34,
                "displaySequence": 1,
                "content": "<p><strong>The merchant for this electronic payment transaction will appear on your billing statement as <u>Alliant Insurance Services</u>.</strong> </p>",
                "contentSectionTypeId": 6,
                "contentSectionType": "PaymentFooter",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 35,
                "displaySequence": 1,
                "content": "This acknowledges receipt of your signed proposal requesting premium financing. We will forward the premium finance agreement for your signature along with the invoice.",
                "contentSectionTypeId": 17,
                "contentSectionType": "PremiumFinanceReceiptBody",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 36,
                "displaySequence": 2,
                "content": "<p><b>Please follow this link to download and view a <a target='_blank' href=\"\\assets\\4\\PolicySpecimen.pdf\">Sample Policy Document</a>.</b> </p>",
                "contentSectionTypeId": 5,
                "contentSectionType": "PaymentBody",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 37,
                "displaySequence": 1,
                "content": "<div class='panel-group'>    <div class='panel panel-default'>        <div class='panel-heading'>            <h4>Policy Information</h4>        </div>        <div class='panel-body'>            <div class='row'>                <div class='col-md-6'>                    <p>                        <strong>Coverage:</strong> Errors and Omissions, Claims Made, HIPAA/HITECH                         <br/>Known Prior Acts Excluded                      </p>                    <p>                        <strong>Professional Services:</strong> The business of translating, interpreting, editing,                         typesetting, desktop publishing, printing, and proof-reading of a document from one language                         to another.                    </p>                </div>                <div class='col-md-6'>                    <p>                        <strong>Policy Term:</strong> TBD = Annual                    </p>                    <p>                        <strong>Retroactive Date:</strong> RDI = Retro Date Inception                    </p>                    <p>                        <strong>Policy Form:</strong> Lloyds of London Professional Liability                    </p>                </div>            </div>        </div>    </div></div>",
                "contentSectionTypeId": 4,
                "contentSectionType": "PaymentHeader",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 38,
                "displaySequence": 6,
                "content": "<p><strong>Please run this application in Internet Explorer v11 or Chrome for optimal performance</strong></p>",
                "contentSectionTypeId": 1,
                "contentSectionType": "Header",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 39,
                "displaySequence": 5,
                "content": "<p>Fax: (703) 563-1510</p>",
                "contentSectionTypeId": 1,
                "contentSectionType": "Header",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 40,
                "displaySequence": 4,
                "content": "<p><strong>Toll Free: (855) 663-2282</strong></p>",
                "contentSectionTypeId": 1,
                "contentSectionType": "Header",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 41,
                "displaySequence": 3,
                "content": "<p>Email: <a href=\"mailto:ata-questions@alliant.com\">ata-questions@alliant.com</a></p>",
                "contentSectionTypeId": 1,
                "contentSectionType": "Header",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 42,
                "displaySequence": 2,
                "content": "<p>&nbsp;If you have any questions regarding your application, please contact us at:</p>",
                "contentSectionTypeId": 1,
                "contentSectionType": "Header",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 43,
                "displaySequence": 1,
                "content": "<h4><strong>Significant Endorsements/ Exclusions:</strong></h4><ul><li>Tower Endorsement</li><li>Year 2000 Exclusion</li><li>NMA 2918 War and Terrorism Exclusion</li><li>NMA 1256 Nuclear Incident Exclusion Clause-Liability (Broad) (USA)</li><li>NMA 1477 Radioactive Contamination Exclusion Clause–Liability-Direct</li><li>LSW 1001 Several Liability Clause</li><li>LMA3100 Sanction Limitation and Exclusion Clause</li><li>HIPAA HITECH Endorsement PG</li><li>Claims-made policy form</li><li>30% minimum earned premium</li></ul><table width=50%><tr><td><b>Insuring Company: </b></td><td>Lloyds of London International Surplus Lines Insurance Company.</td></tr><tr><td>&nbsp;</td><td><b> A.M.Best Rating A(Excellent)</b></td></tr></table><br>",
                "contentSectionTypeId": 5,
                "contentSectionType": "PaymentBody",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            },
            {
                "programEnrollmentContentId": 44,
                "displaySequence": 2,
                "content": "Should you have any questions, please feel free to contact us. Thank you.",
                "contentSectionTypeId": 17,
                "contentSectionType": "PremiumFinanceReceiptBody",
                "programEnrollmentId": 4,
                "createUser": "Migration.Seeder",
                "createDate": "2020-02-05T00:05:53.7128452",
                "lastUpdatedUser": null,
                "lastUpdatedDate": null,
                "disabled": false,
                "systemNotes": null,
                "userEmail": null,
                "errors": [],
                "isSuccessful": true
            }
        ],
        "createUser": "Migration.Seeder",
        "createDate": "2020-02-05T00:05:24.3368249",
        "lastUpdatedUser": "Seed.UpdateSeedProgramEnrollments",
        "lastUpdatedDate": "2020-03-09T18:50:34.1431187",
        "disabled": false,
        "systemNotes": null,
        "userEmail": null,
        "errors": [],
        "isSuccessful": true
    },
    "states": [
        {
            "stateId": 1,
            "stateCode": "AL",
            "stateName": "Alabama",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 2,
            "stateCode": "AK",
            "stateName": "Alaska",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 4,
            "stateCode": "AZ",
            "stateName": "Arizona",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 5,
            "stateCode": "AR",
            "stateName": "Arkansas",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 6,
            "stateCode": "CA",
            "stateName": "California",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 7,
            "stateCode": "CO",
            "stateName": "Colorado",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 8,
            "stateCode": "CT",
            "stateName": "Connecticut",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 9,
            "stateCode": "DE",
            "stateName": "Delaware",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 10,
            "stateCode": "DC",
            "stateName": "Dist. of Columbia",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 11,
            "stateCode": "FL",
            "stateName": "Florida",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 12,
            "stateCode": "GA",
            "stateName": "Georgia",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 14,
            "stateCode": "HI",
            "stateName": "Hawaii",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 15,
            "stateCode": "ID",
            "stateName": "Idaho",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 16,
            "stateCode": "IL",
            "stateName": "Illinois",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 17,
            "stateCode": "IN",
            "stateName": "Indiana",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 18,
            "stateCode": "IA",
            "stateName": "Iowa",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 19,
            "stateCode": "KS",
            "stateName": "Kansas",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 20,
            "stateCode": "KY",
            "stateName": "Kentucky",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 21,
            "stateCode": "LA",
            "stateName": "Louisiana",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 22,
            "stateCode": "ME",
            "stateName": "Maine",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 23,
            "stateCode": "MD",
            "stateName": "Maryland",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 25,
            "stateCode": "MA",
            "stateName": "Massachusetts",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 26,
            "stateCode": "MI",
            "stateName": "Michigan",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 28,
            "stateCode": "MN",
            "stateName": "Minnesota",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 29,
            "stateCode": "MS",
            "stateName": "Mississippi",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 30,
            "stateCode": "MO",
            "stateName": "Missouri",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 31,
            "stateCode": "MT",
            "stateName": "Montana",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 32,
            "stateCode": "NE",
            "stateName": "Nebraska",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 33,
            "stateCode": "NV",
            "stateName": "Nevada",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 34,
            "stateCode": "NH",
            "stateName": "New Hampshire",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 35,
            "stateCode": "NJ",
            "stateName": "New Jersey",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 36,
            "stateCode": "NM",
            "stateName": "New Mexico",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 37,
            "stateCode": "NY",
            "stateName": "New York",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 38,
            "stateCode": "NC",
            "stateName": "North Carolina",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 39,
            "stateCode": "ND",
            "stateName": "North Dakota",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 41,
            "stateCode": "OH",
            "stateName": "Ohio",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 42,
            "stateCode": "OK",
            "stateName": "Oklahoma",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 43,
            "stateCode": "OR",
            "stateName": "Oregon",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 45,
            "stateCode": "PA",
            "stateName": "Pennsylvania",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 47,
            "stateCode": "RI",
            "stateName": "Rhode Island",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 48,
            "stateCode": "SC",
            "stateName": "South Carolina",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 49,
            "stateCode": "SD",
            "stateName": "South Dakota",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 50,
            "stateCode": "TN",
            "stateName": "Tennessee",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 51,
            "stateCode": "TX",
            "stateName": "Texas",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 52,
            "stateCode": "UT",
            "stateName": "Utah",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 53,
            "stateCode": "VT",
            "stateName": "Vermont",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 54,
            "stateCode": "VA",
            "stateName": "Virginia",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 56,
            "stateCode": "WA",
            "stateName": "Washington",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 57,
            "stateCode": "WV",
            "stateName": "West Virginia",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 58,
            "stateCode": "WI",
            "stateName": "Wisconsin",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "stateId": 59,
            "stateCode": "WY",
            "stateName": "Wyoming",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:01.9329114",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        }
    ],
    "countries": [
        {
            "countryId": 236,
            "countryCode": "US",
            "name": "United States",
            "description": "United States of America",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:04:55.9266886",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        }
    ],
    "paymentTypes": [
        {
            "paymentTypeId": 1,
            "description": "Ach",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:04:52.5817228",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "paymentTypeId": 2,
            "description": "CreditCard",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:04:52.5817228",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        }
    ],
    "relationshipTypes": [
        {
            "relationshipTypeId": 1,
            "description": "Owner",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:04:54.9099026",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "relationshipTypeId": 2,
            "description": "Landlord",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:04:54.9099026",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "relationshipTypeId": 3,
            "description": "OnLocation",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:04:54.9099026",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "relationshipTypeId": 4,
            "description": "Other",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:04:54.9099026",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        }
    ],
    "addressTypes": [
        {
            "addressTypeId": 0,
            "description": "None",
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:04:52.3191814",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        }
    ],
    "programEnrollmentContents": [
        {
            "programEnrollmentContentId": 28,
            "displaySequence": 1,
            "content": "<p>We make the process of finding the right professional liability insurance coverage as quick and easy as possible. We can work with you to provide professional liability insurance quotes.</p>",
            "contentSectionTypeId": 1,
            "contentSectionType": "Header",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 29,
            "displaySequence": 1,
            "content": "<font color='red'><strong>Not ready to pay? Select ‘Cancel’ then ‘save quote’ to pay at a later time<strong></font><br />",
            "contentSectionTypeId": 15,
            "contentSectionType": "PremiumFinanceFooter",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 30,
            "displaySequence": 1,
            "content": "<font color='red'><strong>Not ready to pay? Select ‘Cancel’ then ‘save quote’ to pay at a later time<strong></font><br />",
            "contentSectionTypeId": 27,
            "contentSectionType": "AchFooter",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 31,
            "displaySequence": 1,
            "content": "<font color='red'><strong>Not ready to pay? Select ‘Cancel’ then ‘save quote’ to pay at a later time<strong></font><br />",
            "contentSectionTypeId": 21,
            "contentSectionType": "CreditCardFooter",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 32,
            "displaySequence": 2,
            "content": "<p class='text-danger'><strong>Please check the above application to make sure all spelling of names, company, street, city, state, e-mail, phone numbers, etc and information on the application are correct before submitting. Thank you.<strong></p>",
            "contentSectionTypeId": 3,
            "contentSectionType": "Footer",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 33,
            "displaySequence": 1,
            "content": "Applicant represents and warrants to the best of their knowledge that the particulars and statements contained in this application are true and agree that these particulars and statements are the basis of the policy that may be issued, and will constitute a part of the policy. By Submitting this Application, the Applicant agrees that in the event the application contains misrepresentations or fails to state facts materially affecting the risk assumed by the insuring company under a policy issued, the policy may be deemed null and void.",
            "contentSectionTypeId": 3,
            "contentSectionType": "Footer",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 34,
            "displaySequence": 1,
            "content": "<p><strong>The merchant for this electronic payment transaction will appear on your billing statement as <u>Alliant Insurance Services</u>.</strong> </p>",
            "contentSectionTypeId": 6,
            "contentSectionType": "PaymentFooter",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 35,
            "displaySequence": 1,
            "content": "This acknowledges receipt of your signed proposal requesting premium financing. We will forward the premium finance agreement for your signature along with the invoice.",
            "contentSectionTypeId": 17,
            "contentSectionType": "PremiumFinanceReceiptBody",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 36,
            "displaySequence": 2,
            "content": "<p><b>Please follow this link to download and view a <a target='_blank' href=\"\\assets\\4\\PolicySpecimen.pdf\">Sample Policy Document</a>.</b> </p>",
            "contentSectionTypeId": 5,
            "contentSectionType": "PaymentBody",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 37,
            "displaySequence": 1,
            "content": "<div class='panel-group'>    <div class='panel panel-default'>        <div class='panel-heading'>            <h4>Policy Information</h4>        </div>        <div class='panel-body'>            <div class='row'>                <div class='col-md-6'>                    <p>                        <strong>Coverage:</strong> Errors and Omissions, Claims Made, HIPAA/HITECH                         <br/>Known Prior Acts Excluded                      </p>                    <p>                        <strong>Professional Services:</strong> The business of translating, interpreting, editing,                         typesetting, desktop publishing, printing, and proof-reading of a document from one language                         to another.                    </p>                </div>                <div class='col-md-6'>                    <p>                        <strong>Policy Term:</strong> TBD = Annual                    </p>                    <p>                        <strong>Retroactive Date:</strong> RDI = Retro Date Inception                    </p>                    <p>                        <strong>Policy Form:</strong> Lloyds of London Professional Liability                    </p>                </div>            </div>        </div>    </div></div>",
            "contentSectionTypeId": 4,
            "contentSectionType": "PaymentHeader",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 38,
            "displaySequence": 6,
            "content": "<p><strong>Please run this application in Internet Explorer v11 or Chrome for optimal performance</strong></p>",
            "contentSectionTypeId": 1,
            "contentSectionType": "Header",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 39,
            "displaySequence": 5,
            "content": "<p>Fax: (703) 563-1510</p>",
            "contentSectionTypeId": 1,
            "contentSectionType": "Header",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 40,
            "displaySequence": 4,
            "content": "<p><strong>Toll Free: (855) 663-2282</strong></p>",
            "contentSectionTypeId": 1,
            "contentSectionType": "Header",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 41,
            "displaySequence": 3,
            "content": "<p>Email: <a href=\"mailto:ata-questions@alliant.com\">ata-questions@alliant.com</a></p>",
            "contentSectionTypeId": 1,
            "contentSectionType": "Header",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 42,
            "displaySequence": 2,
            "content": "<p>&nbsp;If you have any questions regarding your application, please contact us at:</p>",
            "contentSectionTypeId": 1,
            "contentSectionType": "Header",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 43,
            "displaySequence": 1,
            "content": "<h4><strong>Significant Endorsements/ Exclusions:</strong></h4><ul><li>Tower Endorsement</li><li>Year 2000 Exclusion</li><li>NMA 2918 War and Terrorism Exclusion</li><li>NMA 1256 Nuclear Incident Exclusion Clause-Liability (Broad) (USA)</li><li>NMA 1477 Radioactive Contamination Exclusion Clause–Liability-Direct</li><li>LSW 1001 Several Liability Clause</li><li>LMA3100 Sanction Limitation and Exclusion Clause</li><li>HIPAA HITECH Endorsement PG</li><li>Claims-made policy form</li><li>30% minimum earned premium</li></ul><table width=50%><tr><td><b>Insuring Company: </b></td><td>Lloyds of London International Surplus Lines Insurance Company.</td></tr><tr><td>&nbsp;</td><td><b> A.M.Best Rating A(Excellent)</b></td></tr></table><br>",
            "contentSectionTypeId": 5,
            "contentSectionType": "PaymentBody",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        },
        {
            "programEnrollmentContentId": 44,
            "displaySequence": 2,
            "content": "Should you have any questions, please feel free to contact us. Thank you.",
            "contentSectionTypeId": 17,
            "contentSectionType": "PremiumFinanceReceiptBody",
            "programEnrollmentId": 4,
            "createUser": "Migration.Seeder",
            "createDate": "2020-02-05T00:05:53.7128452",
            "lastUpdatedUser": null,
            "lastUpdatedDate": null,
            "disabled": false,
            "systemNotes": null,
            "userEmail": null,
            "errors": [],
            "isSuccessful": true
        }
    ],
    "relatedParticipantEnrollments": null,
    "previousParticipantRatingItems": null,
    "supportEmail": null,
    "submittedBy": null,
    "submitDate": null,
    "createUser": null,
    "createDate": "0001-01-01T00:00:00",
    "lastUpdatedUser": null,
    "lastUpdatedDate": null,
    "disabled": false,
    "systemNotes": null,
    "userEmail": null,
    "errors": [],
    "isSuccessful": true
}
